/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DocBits - API
 * DocBits - API
 * OpenAPI spec version: 11.97.2
 */
import type {
  BodyGetDbCredentialsPreferencesGetDbCredentialsPut,
  BodyGetDocumentTypeRegexesPreferencesGetDocumentTypeRegexesPost,
  BodyGetOrganisationPreferencePreferencesGetOrganisationPreferencePost,
  BodyRemoveUserPreferencePreferencesRemoveUserPreferenceDelete,
  BodyResetWarhouseUserPreferencesResetWarhouseUserPut,
  BodySendMessagePreferencesSendMessagePut,
  BodySetBodConnectionStreamPreferencePreferencesSetBodConnectionStreamPreferencePut,
  BodySetCachePreferencePreferencesSetCachePreferencePut,
  BodySetGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut,
  BodySetGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePut,
  BodySetPreferencePreferencesSetPreferencePut,
  BodySetPreferencesPreferencesSetPreferencesPut,
  BodySetReportingEnginePreferencePreferencesSetReportingEnginePreferencePut,
  BodySetTfidfPreferencePreferencesSetTfidfPreferencePut,
  BodySetUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut,
  BodySetUserPreferenceSyncPreferencesSetUserPreferencePut,
  BodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost,
  DeleteCacheForOrgPreferencesDeleteCacheForOrgDeleteParams,
  FetchRedisCacheDataPreferencesFetchRedisCacheDataGetParams,
  GetBodConnectionStreamPreferencePreferencesGetBodConnectionStreamPreferenceGetParams,
  GetCachePreferencePreferencesGetCachePreferenceGetParams,
  GetPreferencePreferencesGetPreferenceGetParams,
  GetPreferencesPreferencesGetPreferencesGetParams,
  GetTfidfPreferenceSyncPreferencesGetTfidfPreferenceGetParams,
  GetTfidfPreferencesByOrgIdPreferencesGetTfidfPreferencesByOrgIdGetParams,
  GetUserPreferencePreferencesGetUserPreferenceGetParams,
  GetUserPreferencesPreferencesGetUserPreferencesGetParams,
  GetWarehouseUserPreferencePreferencesGetWarehouseUserPreferenceGetParams,
  RemovePreferencePreferencesRemovePreferenceDeleteParams,
  RemoveTfidfPreferencesPreferencesRemoveTfidfPreferencesDeleteParams,
  SuccessResponse,
  UserPreferenceResponse,
} from '.././models';

import { customAxiosInstance } from '../../mutator/custom-axios-instance';

export const getUserPreferences = () => {
  /**
 * Clears all cached data for an organization from Redis memory. This forces the system to fetch fresh data from the database on the next request.

**Cache Clearing Behavior:**
- **Scope**: Organization-wide cache invalidation (affects all users in org)
- **Scope**: User-specific preference cache (current user's cached preferences)
- **Atomicity**: Both organization and user caches cleared together
- **Effect**: Immediate (changes visible on next API call)
- **Recovery**: Data fetched fresh from database after cache clear

**Cache Groups Cleared:**
The endpoint clears ALL cache groups for the organization:
- `preferences`: User and organization preference caching
- `document_types`: Document type and field configuration cache
- `document_attributes`: Document type attributes cache
- `dashboard`: Dashboard data aggregation cache
- `extraction`: Extraction patterns and field matching cache
- `validation`: Validation rules cache
- All other cached data for the organization (wildcard `*`)

**User-specific Caches Cleared:**
- User's preference cache (even if org_id differs)
- User's dashboard personalization cache
- User's recent searches or filters cache

**Parameters:**
- `org_id` (required, Query): Organization UUID to clear cache for
  - Must match authenticated user's organization
  - Case-sensitive UUID format
  - Validates user has access to this organization
- User authentication required via Bearer token

**Response on Success:**
```json
{
  "success": true,
  "message": "All cache for org_id org-uuid-12345 cleared successfully."
}
```

**Response on Failure:**
```json
{
  "success": false,
  "message": "Redis connection error: [error details]"
}
```

**Logging:**
- Success logged as INFO: `"cache cleared for org_id: {org_id}"`
- Failure logged as EXCEPTION with full error details
- Audit trail records cache invalidation events

**Error Responses:**
- 200: Cache successfully cleared for organization
- 400: Invalid organization UUID format
- 401: User authentication failed
- 403: User lacks permission for this organization
- 500: Redis connection error or cache operation failure
  - Returns `success: false` in response body

**Cache Impact Analysis:**
After cache clear, next requests will:
1. Query database directly (slower, but fresh data)
2. Results cached again in Redis (with original TTL)
3. Subsequent requests use cache (normal performance restored)

**Performance Considerations:**
- Cache clear is immediate and non-blocking
- Minimal impact on system performance
- Next requests may be slightly slower (database hits)
- Performance returns to normal within seconds (as cache rebuilds)

**Use Cases:**
1. **Configuration Update**: Force reload after admin changes settings
2. **Bug Recovery**: Clear corrupted cached data manually
3. **Data Sync Issues**: Ensure fresh data after sync problems
4. **Testing**: Start with clean state during testing
5. **Performance Troubleshooting**: Identify if issue is stale cache

**Comparison with Other Endpoints:**
- `/set_preference`: Updates preference + auto-clears affected cache
- `/set_preferences`: Batch update + auto-clears affected cache
- `/delete_cache_for_org`: Manual full cache clear (this endpoint) ← THIS ENDPOINT
- Difference: This endpoint clears ALL caches, not just preferences

**Related Operations:**
- Cache is automatically invalidated when preferences change
- Dashboard cache cleared when grouping preferences updated
- Attribute cache cleared when document type attributes change
- User preference cache cleared for current user

**Example Requests:**

Clear all cache for organization:
```bash
curl -X DELETE "https://api.docbits.com/preferences/delete_cache_for_org?org_id=org-uuid-12345" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN"
```

Python example:
```python
import requests

response = requests.delete(
    "https://api.docbits.com/preferences/delete_cache_for_org",
    params={"org_id": org_uuid},
    headers={"Authorization": f"Bearer {token}"}
)

if response.model_dump_json()["success"]:
    logger.debug("Cache cleared successfully")
else:
    logger.debug(f"Cache clear failed: {response.model_dump_json()['message']}")
```

**Important Notes:**
- Async operation using `async def` (non-blocking)
- Affects ALL users in organization (organization-wide)
- Also clears the current user's preference cache
- Safe operation (no data loss, only cache invalidation)
- Should be used sparingly (cache automatically invalidates on changes)
- Useful for troubleshooting and recovery scenarios
 * @summary Clear all Redis cache for an organization
 */
  const deleteCacheForOrgPreferencesDeleteCacheForOrgDelete = (
    params: DeleteCacheForOrgPreferencesDeleteCacheForOrgDeleteParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/delete_cache_for_org`,
      method: 'DELETE',
      params,
    });
  };
  /**
 * Retrieves all system preferences for an organization. These preferences control global behavior across the entire DocBits system for that organization.

**Organization Preferences** include:
- `DOCUMENT_TIMEOUT`: Processing timeout in seconds for document jobs
- `MAX_FILE_SIZE`: Maximum allowed document size in bytes
- `ENABLE_FUZZY_MATCHING`: Enable approximate field matching for extraction
- `DEFAULT_CONFIDENCE_THRESHOLD`: Minimum confidence score (0-100) for field extraction
- `EMAIL_NOTIFICATIONS`: Enable email alerts for completed documents
- `WEBHOOK_ENABLED`: Enable webhook integrations for document callbacks
- `STORAGE_BUCKET`: Cloud storage bucket configuration
- `ERP_INTEGRATION_MODE`: ERP system integration settings
- `OCR_ENGINE`: Selected OCR engine (Tesseract, DocumentAI, etc.)
- `LANGUAGE_PREFERENCE`: Default language for OCR and processing

**Key Features:**
- Returns complete organization configuration
- Cached for 6 hours to optimize performance
- Scope: Organization-level, applies to all users and documents
- Used during system initialization and configuration screens
- Real-time reflection of administrative settings

**Parameters:**
- `org_id` (required, string): Organization UUID from user's token profile
  - Must match authenticated user's organization membership
  - Determines which organization's preferences are returned

**Response:**
```json
{
  "success": true,
  "data": {
    "DOCUMENT_TIMEOUT": "300",
    "MAX_FILE_SIZE": "52428800",
    "ENABLE_FUZZY_MATCHING": "true",
    "DEFAULT_CONFIDENCE_THRESHOLD": "75",
    "EMAIL_NOTIFICATIONS": "true",
    "WEBHOOK_ENABLED": "true",
    "STORAGE_BUCKET": "docbits-prod-bucket",
    "ERP_INTEGRATION_MODE": "production",
    "OCR_ENGINE": "DocumentAI",
    "LANGUAGE_PREFERENCE": "en"
  }
}
```

**Cache Behavior:**
- 6-hour TTL (time-to-live) for performance
- Invalidated when any preference is modified
- Organization-specific cache keys prevent cross-org leakage
- Cache warming on first request for that organization

**Error Responses:**
- 401: User authentication failed or missing Bearer token
- 403: User lacks permission for this organization
- 404: Organization not found or no preferences configured
- 500: Database connection error or preference service failure

**Use Cases:**
1. **System Initialization**: Load org settings on application startup
2. **Configuration UI**: Display current settings in admin panel
3. **Feature Toggles**: Check if specific features are enabled
4. **Resource Limits**: Validate document size against MAX_FILE_SIZE
5. **Processing Pipeline**: Get timeout and engine settings for document jobs

**Related Endpoints:**
- `PUT /set_preference`: Update a single preference key
- `PUT /set_preferences`: Batch update multiple preferences
- `GET /get_preference`: Get a specific preference by key
- `DELETE /remove_preference`: Delete a preference and revert to default

**Example Request:**
```bash
curl -X GET "https://api.docbits.com/preferences/get_preferences?org_id=org-uuid-12345" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN"
```

**Example Errors:**

Authentication error:
```json
{
  "detail": "Invalid or expired authentication token"
}
```

Organization not found:
```json
{
  "detail": "Organization 'org-invalid-uuid' not found"
}
```
 * @summary Get all organization preferences
 */
  const getPreferencesPreferencesGetPreferencesGet = (
    params?: GetPreferencesPreferencesGetPreferencesGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/get_preferences`,
      method: 'GET',
      params,
    });
  };
  /**
 * Retrieves all user-specific preferences for the authenticated user in their organization.

    **User Isolation:** Each user sees only their own preferences, not other users' preferences.

    **Use Case:** Typically used during login to hydrate the frontend's preference store.

    **Performance Note:** This endpoint uses async/await to prevent blocking the event loop,
    enabling proper connection pooling and better concurrency under load.

    **Cache Metadata:** When served from cache, response includes `__cached`, `__cached_key`,
    `__cache_duration`, and `__cached_on` fields.
 * @summary Get all user preferences in organization
 */
  const getUserPreferencesPreferencesGetUserPreferencesGet = (
    params?: GetUserPreferencesPreferencesGetUserPreferencesGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/get_user_preferences`,
      method: 'GET',
      params,
    });
  };
  /**
 * Retrieves a specific organization-level preference value by its key name.

**Organization Preference Keys** (common examples):
- `DOCUMENT_TIMEOUT`: Processing timeout in seconds (e.g., "300")
- `MAX_FILE_SIZE`: Maximum file size in bytes (e.g., "52428800")
- `ENABLE_FUZZY_MATCHING`: Boolean flag as string (e.g., "true", "false")
- `DEFAULT_CONFIDENCE_THRESHOLD`: Score 0-100 (e.g., "75")
- `EMAIL_NOTIFICATIONS`: Boolean flag (e.g., "true")
- `WEBHOOK_ENABLED`: Boolean flag (e.g., "true")
- `STORAGE_BUCKET`: Cloud storage bucket name (e.g., "docbits-prod-bucket")
- `ERP_INTEGRATION_MODE`: Integration mode (e.g., "production", "sandbox")
- `OCR_ENGINE`: Selected OCR service (e.g., "DocumentAI", "Tesseract")
- `LANGUAGE_PREFERENCE`: Default language (e.g., "en", "de", "es")

**Key Characteristics:**
- Returns a single string value for the specified key
- Scope: Organization-level (applies to all users and documents in organization)
- Returns null/empty if key is not set for organization
- Used for real-time configuration lookups
- Lightweight alternative to fetching all preferences when only one is needed

**Parameters:**
- `org_id` (required, string): Organization UUID from user's token profile
  - Must match authenticated user's organization membership
  - Case-sensitive UUID format
- `key` (required, string): Name of the preference key to retrieve
  - Case-sensitive, matches key name in database
  - Unknown keys return empty/null response

**Response:**
```
200 OK
Content-Type: text/plain

300
```

Or for boolean/complex values:
```
true
```

**Response Codes:**
- 200: Preference found and returned as plain text string
- 204: Preference key not configured for this organization (no value set)
- 400: Invalid parameters (malformed org_id, missing key)
- 401: User authentication failed
- 403: User lacks permission for this organization
- 404: Organization not found
- 500: Database or service error

**Use Cases:**
1. **Feature Toggles**: Check if feature is enabled (e.g., "WEBHOOK_ENABLED")
2. **Timeout Configuration**: Get timeout value for job processing
3. **Resource Limits**: Fetch MAX_FILE_SIZE for validation
4. **Integration Settings**: Get ERP_INTEGRATION_MODE for business process
5. **Runtime Configuration**: Load single setting without fetching all preferences

**Cache Behavior:**
- Currently not cached (returns fresh value from database each request)
- Can be cached per organization and key if needed
- Cache key would be: `preference:{org_id}:{key}`

**Difference from `/get_preferences`:**
- `/get_preferences`: Returns ALL org preferences as dictionary (6-hour cache)
- `/get_preference`: Returns SINGLE value by key (no cache, real-time)

**Example Requests:**

Get document timeout:
```bash
curl -X GET "https://api.docbits.com/preferences/get_preference?org_id=org-uuid&key=DOCUMENT_TIMEOUT" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN"
```

Response:
```
300
```

Get fuzzy matching flag:
```bash
curl -X GET "https://api.docbits.com/preferences/get_preference?org_id=org-uuid&key=ENABLE_FUZZY_MATCHING" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN"
```

Response:
```
true
```

Key not configured (204 No Content):
```bash
curl -X GET "https://api.docbits.com/preferences/get_preference?org_id=org-uuid&key=UNKNOWN_KEY" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN"
```

Response: Empty (204 No Content)
 * @summary Get a single organization preference value by key
 */
  const getPreferencePreferencesGetPreferenceGet = (
    params: GetPreferencePreferencesGetPreferenceGetParams,
  ) => {
    return customAxiosInstance<unknown | void>({
      url: `/preferences/get_preference`,
      method: 'GET',
      params,
    });
  };
  /**
 * Retrieves a specific user preference value (e.g., language preference).

    **User Isolation:** Returns only the authenticated user's preference, independent of other users.

    **Supported Keys:** PREFERRED_LANGUAGE, THEME, TIMEZONE, etc.

    **For PREFERRED_LANGUAGE:** Supported values are: en-us, de, es-es, fr, nl, it, zh

    **Important:** The `org_id` parameter must match the organization ID from the user's token profile (via OAuth2).

    **Critical Note for Frontend:**
    - `org_id` must be extracted from the user token profile AFTER login, not from URL or localStorage
    - If you pass the wrong `org_id`, you may get another user's preference or null
 * @summary Get a single user preference value
 */
  const getUserPreferencePreferencesGetUserPreferenceGet = (
    params: GetUserPreferencePreferencesGetUserPreferenceGetParams,
  ) => {
    return customAxiosInstance<unknown | void>({
      url: `/preferences/get_user_preference`,
      method: 'GET',
      params,
    });
  };
  /**
 * Retrieves a specific TF-IDF (Term Frequency-Inverse Document Frequency) preference value for a given document type within an organization. TF-IDF models are used for extracting and scoring relevant fields from documents.

**TFIDF Preference Overview:**
TF-IDF preferences configure machine learning models for intelligent field extraction. Each preference stores model configuration, scoring thresholds, and field patterns for specific document types.

**Preference Scope and Structure:**
- **Scope**: Organization + TFIDF Model level (applies to specific ML model configuration)
- **Hierarchy**: org_id → tfidf_id → key → value (nested preference structure)
- **Usage**: ML field extraction configuration, pattern matching rules, scoring thresholds
- **Model Types**: INVOICE, PURCHASE_ORDER, RECEIPT, DELIVERY_NOTE, CREDIT_NOTE, etc.
- **Configuration Keys**: CONFIDENCE_THRESHOLD, PATTERN_MODE, FUZZY_MATCHING, FIELD_PRIORITY, etc.

**Parameters:**
- `org_id` (required, Query): Organization UUID where TFIDF model is configured
  - Must match authenticated user's organization
  - Validates that user has access to organization data
- `tfidf_id` (required, Query): Unique identifier of the TFIDF model
  - Format: UUID or model name (e.g., "invoice-extraction-v2")
  - Example: "f47ac10b-58cc-4372-a567-0e02b2c3d479"
- `key` (required, Query): Configuration key name for TFIDF model (case-sensitive)
  - Example keys:
    - `CONFIDENCE_THRESHOLD`: Minimum confidence score (0-100)
    - `PATTERN_MODE`: Matching pattern strategy (EXACT, FUZZY, REGEX)
    - `FIELD_PRIORITY`: Priority scoring for multi-field extraction (HIGH, MEDIUM, LOW)
    - `FUZZY_MATCHING`: Enable fuzzy pattern matching (true/false)
    - `BATCH_SIZE`: Number of documents per batch (int, 1-1000)
    - `CACHE_TTL`: Cache validity in seconds (int, 300-86400)

**Response Structure:**
Returns the preference value as a plain text string. The value format depends on the key:
- Numeric keys return string-encoded numbers: "75", "300", "1000"
- Boolean keys return: "true" or "false"
- String keys return configuration names: "EXACT", "FUZZY", "REGEX"
- JSON keys (rare) return: string-encoded JSON (requires client-side parsing)

**Use Cases:**

1. **ML Model Configuration Retrieval**:
   - Fetch current confidence threshold for document classification
   - Load field extraction patterns before processing batch
   - Client: "What's the minimum confidence score for invoice OCR?"

2. **A/B Testing and Experiments**:
   - Compare different TFIDF model configurations
   - Test pattern matching modes on sample documents
   - Client: "Is fuzzy matching enabled for this model?"

3. **Performance Tuning**:
   - Retrieve cache TTL for optimization decisions
   - Check batch size for bulk processing
   - Client: "What's the optimal batch size for this model?"

4. **Dynamic Feature Toggle**:
   - Retrieve feature flags without model restart
   - Load model-specific preprocessing options
   - Client: "Is advanced pattern matching enabled?"

5. **Model Versioning**:
   - Fetch version-specific configuration for model variants
   - Support multiple model versions running simultaneously
   - Client: "What's the pattern mode for model v2?"

**Error Responses:**
- **200 OK**: Preference value found and returned
  - Example: "75" (confidence threshold as string)
  - Example: "true" (boolean as string)
  - Example: "FUZZY" (enum value as string)
- **400 Bad Request**: Invalid parameters (missing org_id, tfidf_id, or key format)
  - Response: `{"error": "Invalid organization UUID format", "detail": "org_id must be valid UUID"}`
  - Response: `{"error": "Missing required parameter: tfidf_id", "detail": "tfidf_id is required"}`
- **401 Unauthorized**: User authentication failed or token expired
  - Response: `{"error": "Unauthorized", "detail": "Invalid or missing authentication token"}`
- **403 Forbidden**: User lacks permission to access organization or TFIDF model
  - Response: `{"error": "Forbidden", "detail": "User not authorized for this organization"}`
- **404 Not Found**: Preference not configured for this organization/model combination
  - Response: `{"error": "Not Found", "detail": "TFIDF preference not found for model 'invoice-v2'"}`
  - Response: `{"error": "Configuration Missing", "detail": "Key 'CONFIDENCE_THRESHOLD' not set"}`
- **500 Internal Server Error**: Database query error or service failure
  - Response: `{"error": "Server Error", "detail": "Database connection failed"}`

**Related Endpoints:**
- `PUT /set_tfidf_preference` - Update TFIDF preference configuration
- `GET /get_tfidf_preferences_by_org_id` - Fetch all TFIDF preferences for organization
- `DELETE /remove_tfidf_preferences` - Delete TFIDF preference configuration
- `GET /get_preference` - Get flat preference (non-TFIDF)
- `PUT /set_preference` - Update flat preference

**Example Request:**
```bash
# Get confidence threshold for TFIDF invoice extraction model
curl -X GET "https://api.docbits.com/preferences/get_tfidf_preference?org_id=550e8400-e29b-41d4-a716-446655440000&tfidf_id=invoice-extraction-v2&key=CONFIDENCE_THRESHOLD" \
  -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."

# Get pattern matching mode for PO extraction
curl -X GET "https://api.docbits.com/preferences/get_tfidf_preference?org_id=550e8400-e29b-41d4-a716-446655440000&tfidf_id=po-extraction-v1&key=PATTERN_MODE" \
  -H "Authorization: Bearer YOUR_TOKEN"
```

**Example Python SDK Usage:**
```python
import requests
from typing import Optional

class DocBitsAPIClient:
    def __init__(self, api_url: str, token: str):
        self.api_url = api_url
        self.token = token
        self.headers = {"Authorization": f"Bearer {token}"}

    def get_tfidf_preference(
        self,
        org_id: str,
        tfidf_id: str,
        key: str
    ) -> Optional[str]:
        """Get TFIDF model preference configuration."""
        params = {
            "org_id": org_id,
            "tfidf_id": tfidf_id,
            "key": key
        }
        response = requests.get(
            f"{self.api_url}/preferences/get_tfidf_preference",
            params=params,
            headers=self.headers,
            timeout=10
        )

        if response.status_code == 200:
            return response.text.strip('"')  # Plain text response
        elif response.status_code == 404:
            logger.debug(f"Preference '{key}' not configured for model '{tfidf_id}'")
            return None
        else:
            response.raise_for_status()

# Usage example
client = DocBitsAPIClient(
    api_url="https://api.docbits.com",
    token="your_jwt_token"
)

# Get confidence threshold
confidence = client.get_tfidf_preference(
    org_id="550e8400-e29b-41d4-a716-446655440000",
    tfidf_id="invoice-extraction-v2",
    key="CONFIDENCE_THRESHOLD"
)
if confidence:
    logger.debug(f"Confidence threshold: {confidence}")  # Output: "75"

# Get pattern mode
pattern_mode = client.get_tfidf_preference(
    org_id="550e8400-e29b-41d4-a716-446655440000",
    tfidf_id="invoice-extraction-v2",
    key="PATTERN_MODE"
)
if pattern_mode:
    logger.debug(f"Pattern mode: {pattern_mode}")  # Output: "FUZZY"

# Get batch size for processing
batch_size = client.get_tfidf_preference(
    org_id="550e8400-e29b-41d4-a716-446655440000",
    tfidf_id="po-extraction-v1",
    key="BATCH_SIZE"
)
if batch_size:
    size = int(batch_size)
    logger.debug(f"Processing batch size: {size}")  # Output: 50
```

**Response Format:**
Plain text string (not JSON). Content-Type: text/plain

```
75
```

Or with error (JSON response on failure):
```json
{
  "error": "Not Found",
  "detail": "TFIDF preference 'CONFIDENCE_THRESHOLD' not found for model 'invoice-v2'"
}
```
 * @summary Get a single TFIDF model preference configuration
 */
  const getTfidfPreferenceSyncPreferencesGetTfidfPreferenceGet = (
    params: GetTfidfPreferenceSyncPreferencesGetTfidfPreferenceGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/get_tfidf_preference`,
      method: 'GET',
      params,
    });
  };
  /**
 * Sets or updates a single organization-level preference value. This is the primary endpoint for modifying individual system configuration settings.

**Preference Scope and Behavior:**
- **Scope**: Organization-level (applies to entire organization, not individual users)
- **Atomicity**: Single key-value update (not batch operation)
- **Audit Trail**: Every preference change is logged with user_id, timestamp, and change details
- **Cache Invalidation**: Automatically clears related caches after update
- **Persistence**: Changes persist until explicitly deleted or overwritten

**Supported Preference Keys:**
- `DOCUMENT_TIMEOUT`: Processing timeout in seconds (e.g., "300")
- `MAX_FILE_SIZE`: Maximum file size in bytes (e.g., "52428800")
- `ENABLE_FUZZY_MATCHING`: Boolean (e.g., "true", "false")
- `DEFAULT_CONFIDENCE_THRESHOLD`: Score 0-100 (e.g., "75")
- `EMAIL_NOTIFICATIONS`: Boolean (e.g., "true")
- `WEBHOOK_ENABLED`: Boolean (e.g., "true")
- `STORAGE_BUCKET`: Storage bucket name (e.g., "docbits-prod")
- `ERP_INTEGRATION_MODE`: Mode string (e.g., "production", "sandbox")
- `OCR_ENGINE`: Engine name (e.g., "DocumentAI", "Tesseract")
- `LANGUAGE_PREFERENCE`: Language code (e.g., "en", "de", "es")

**Parameters:**
- `org_id` (required, Form): Organization UUID
  - Must match authenticated user's organization
  - Cannot be overridden; uses user's profile org_id
- `key` (required, Form): Preference key name (case-sensitive)
  - Must match valid preference key in system
  - Unknown keys may create new custom preferences
- `value` (optional, Form): Value to set for the preference
  - String representation of value (converted to appropriate type)
  - Omitting value or passing empty string may revert to default
  - Max length typically 1000 characters

**Response on Success:**
```json
{
  "success": true,
  "data": {
    "id": "550e8400-e29b-41d4-a716-446655440000",
    "org_id": "org-uuid-12345",
    "pref_key": "DOCUMENT_TIMEOUT",
    "pref_value": "300",
    "created_at": "2024-10-23T15:30:45Z",
    "updated_at": "2024-10-23T16:45:30Z"
  }
}
```

**Response on Failure:**
```json
{
  "success": false,
  "message": "An error occurred while setting preference."
}
```

**Audit Logging:**
Every successful preference update triggers activity log entry:
- Log Type: `org-preference`
- Message: `User updated org {key} to {value}`
- Records: user_id, organization_id, timestamp, change details

**Error Responses:**
- 200/400: Key not recognized or value validation failed
  - Returns `success: false` in JSON response (not HTTP status codes)
- 401: User authentication failed
- 403: User lacks permission to modify organization preferences
- 500: Database transaction failure or service error

**Use Cases:**
1. **Configuration Updates**: Change document timeout for organization
2. **Feature Toggles**: Enable/disable fuzzy matching or webhooks
3. **Resource Limits**: Update MAX_FILE_SIZE for organization
4. **Integration Settings**: Update ERP_INTEGRATION_MODE
5. **Language Settings**: Update LANGUAGE_PREFERENCE

**Differences from Related Endpoints:**
- `/set_preference`: Single key-value update (this endpoint)
- `/set_preferences`: Batch update multiple keys (more efficient for bulk changes)
- `/get_preference`: Retrieve single key value (read operation)
- `/get_preferences`: Retrieve all keys at once (read operation)

**Example Requests:**

Set document timeout to 5 minutes:
```bash
curl -X PUT "https://api.docbits.com/preferences/set_preference" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=org-uuid-12345&key=DOCUMENT_TIMEOUT&value=300"
```

Enable fuzzy matching:
```bash
curl -X PUT "https://api.docbits.com/preferences/set_preference" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=org-uuid-12345&key=ENABLE_FUZZY_MATCHING&value=true"
```

Update confidence threshold to 80%:
```bash
curl -X PUT "https://api.docbits.com/preferences/set_preference" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=org-uuid-12345&key=DEFAULT_CONFIDENCE_THRESHOLD&value=80"
```

Reset to default (empty value):
```bash
curl -X PUT "https://api.docbits.com/preferences/set_preference" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=org-uuid-12345&key=DOCUMENT_TIMEOUT&value="
```
 * @summary Set or update a single organization preference
 */
  const setPreferencePreferencesSetPreferencePut = (
    bodySetPreferencePreferencesSetPreferencePut: BodySetPreferencePreferencesSetPreferencePut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (
      bodySetPreferencePreferencesSetPreferencePut.org_id !== undefined &&
      bodySetPreferencePreferencesSetPreferencePut.org_id !== null
    ) {
      formUrlEncoded.append(
        `org_id`,
        bodySetPreferencePreferencesSetPreferencePut.org_id,
      );
    }
    formUrlEncoded.append(
      `key`,
      bodySetPreferencePreferencesSetPreferencePut.key,
    );
    if (bodySetPreferencePreferencesSetPreferencePut.value !== undefined) {
      formUrlEncoded.append(
        `value`,
        bodySetPreferencePreferencesSetPreferencePut.value,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/preferences/set_preference`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Updates multiple organization-level preferences in a single atomic transaction. This is the most efficient way to update many preferences at once.

**Batch Operation Benefits:**
- **Atomicity**: All preferences updated together or none at all (transactional)
- **Efficiency**: Single database transaction vs. multiple individual updates
- **Consistency**: Multiple related settings stay synchronized
- **Audit**: Single activity log entry for batch update
- **Performance**: Reduces network requests for bulk configuration changes

**Data Format:**
The `data` parameter accepts JSON string containing key-value pairs:

```json
{
  "DOCUMENT_TIMEOUT": "300",
  "MAX_FILE_SIZE": "52428800",
  "ENABLE_FUZZY_MATCHING": "true",
  "DEFAULT_CONFIDENCE_THRESHOLD": "75",
  "WEBHOOK_ENABLED": "true"
}
```

**Supported Preference Keys** (update any/all of these):
- `DOCUMENT_TIMEOUT`: Processing timeout in seconds
- `MAX_FILE_SIZE`: Maximum file size in bytes
- `ENABLE_FUZZY_MATCHING`: Boolean flag for fuzzy matching
- `DEFAULT_CONFIDENCE_THRESHOLD`: Confidence score 0-100
- `EMAIL_NOTIFICATIONS`: Boolean flag for email alerts
- `WEBHOOK_ENABLED`: Boolean flag for webhook integration
- `STORAGE_BUCKET`: Cloud storage bucket name
- `ERP_INTEGRATION_MODE`: Integration mode (production, sandbox)
- `OCR_ENGINE`: OCR service name (DocumentAI, Tesseract)
- `LANGUAGE_PREFERENCE`: Default language code

**Parameters:**
- `org_id` (required, Form): Organization UUID
  - Must match authenticated user's organization
  - Uses user's profile org_id (cannot be overridden)
- `data` (required, Form): JSON string containing preference key-value pairs
  - Must be valid JSON (properly escaped if sent as form data)
  - Each value is converted to string internally
  - Unknown keys may create new custom preferences

**Response on Success:**
```json
{
  "success": true,
  "data": {
    "updated_count": 5,
    "preferences": {
      "DOCUMENT_TIMEOUT": "300",
      "MAX_FILE_SIZE": "52428800",
      "ENABLE_FUZZY_MATCHING": "true",
      "DEFAULT_CONFIDENCE_THRESHOLD": "75",
      "WEBHOOK_ENABLED": "true"
    },
    "updated_at": "2024-10-23T16:45:30Z"
  }
}
```

**Response on Partial Failure:**
```json
{
  "success": false,
  "message": "An error occurred while setting preference."
}
```

**Audit Logging:**
Single activity log entry is created:
- Log Type: `org-preference`
- Message: `User updated multiple preferences for org {org_id}`
- Records: user_id, organization_id, timestamp, all changed preferences

**Cache Invalidation:**
- Clears all preference-related caches for organization
- Subsequent reads will fetch fresh data
- No stale data returned after batch update

**Error Responses:**
- 200/400: Invalid JSON format or unrecognized keys
  - Returns `success: false` in response body (not HTTP status codes)
- 401: User authentication failed
- 403: User lacks permission to modify organization preferences
- 500: Database transaction failure or service error

**Use Cases:**
1. **Initial Setup**: Configure all organization settings on first run
2. **Migration**: Update settings when changing ERP systems
3. **Feature Rollout**: Enable multiple related features together
4. **Performance Tuning**: Update timeout and confidence settings together
5. **Multi-Tenant Configuration**: Batch configure organization during onboarding

**Differences from Related Endpoints:**
- `/set_preference`: Single key-value update (individual changes)
- `/set_preferences`: Multiple key-value updates (batch, atomic) ← THIS ENDPOINT
- `/get_preference`: Retrieve single key value
- `/get_preferences`: Retrieve all keys at once

**JSON Format Examples:**

Example 1: Initialize all core settings (send as form data):
```bash
curl -X PUT "https://api.docbits.com/preferences/set_preferences" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d 'org_id=org-uuid-12345&data={"DOCUMENT_TIMEOUT":"300","MAX_FILE_SIZE":"52428800","ENABLE_FUZZY_MATCHING":"true","DEFAULT_CONFIDENCE_THRESHOLD":"75"}'
```

Example 2: Update extraction and integration settings:
```bash
curl -X PUT "https://api.docbits.com/preferences/set_preferences" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d 'org_id=org-uuid-12345&data={"ENABLE_FUZZY_MATCHING":"true","DEFAULT_CONFIDENCE_THRESHOLD":"85","ERP_INTEGRATION_MODE":"production","WEBHOOK_ENABLED":"true"}'
```

Example 3: Batch feature toggle (Python):
```python
import requests
import json

preferences = {
    "WEBHOOK_ENABLED": "true",
    "EMAIL_NOTIFICATIONS": "true",
    "ENABLE_FUZZY_MATCHING": "true"
}

response = requests.put(
    "https://api.docbits.com/preferences/set_preferences",
    headers={"Authorization": f"Bearer {token}"},
    data={
        "org_id": org_uuid,
        "data": json.dumps(preferences)
    }
)

logger.debug(response.model_dump_json())
```

**Important Notes:**
- Requires async processing (`async def` function)
- All updates happen atomically (all or nothing)
- More efficient than calling `/set_preference` multiple times
- Recommended for configuration bulk updates
 * @summary Batch update multiple organization preferences
 */
  const setPreferencesPreferencesSetPreferencesPut = (
    bodySetPreferencesPreferencesSetPreferencesPut: BodySetPreferencesPreferencesSetPreferencesPut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodySetPreferencesPreferencesSetPreferencesPut.org_id,
    );
    formUrlEncoded.append(
      `data`,
      bodySetPreferencesPreferencesSetPreferencesPut.data,
    );

    return customAxiosInstance<unknown>({
      url: `/preferences/set_preferences`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Sets a user-specific preference for the authenticated user in their organization.

    **USER ISOLATION:** Each user has their own preference, independent of other users.
    Setting a preference for User A does NOT affect User B's preference.

    **Supported Preference Keys:**
    - PREFERRED_LANGUAGE: Set user's language (en-us, de, es-es, fr, nl, it, zh)
    - THEME: Set UI theme
    - TIMEZONE: Set user's timezone

    **HTTP Method:** PUT (NOT POST)

    **Authentication:** Requires valid bearer token in Authorization header.

    **Critical Parameter:** org_id must be extracted from user token profile (via OAuth2),
    NOT from URL or localStorage. If org_id doesn't match the user's actual organization,
    the request will fail.

    **Frontend Must Do:**
    1. After login, call OAuth2 profile endpoint to get user's org_id
    2. Store this org_id in state/context
    3. Pass this org_id in EVERY preference API call
    4. Update org_id if user logs out and another user logs in
 * @summary Set user-level preference (e.g., language)
 */
  const setUserPreferenceSyncPreferencesSetUserPreferencePut = (
    bodySetUserPreferenceSyncPreferencesSetUserPreferencePut: BodySetUserPreferenceSyncPreferencesSetUserPreferencePut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (
      bodySetUserPreferenceSyncPreferencesSetUserPreferencePut.org_id !==
        undefined &&
      bodySetUserPreferenceSyncPreferencesSetUserPreferencePut.org_id !== null
    ) {
      formUrlEncoded.append(
        `org_id`,
        bodySetUserPreferenceSyncPreferencesSetUserPreferencePut.org_id,
      );
    }
    formUrlEncoded.append(
      `key`,
      bodySetUserPreferenceSyncPreferencesSetUserPreferencePut.key,
    );
    if (
      bodySetUserPreferenceSyncPreferencesSetUserPreferencePut.value !==
      undefined
    ) {
      formUrlEncoded.append(
        `value`,
        bodySetUserPreferenceSyncPreferencesSetUserPreferencePut.value,
      );
    }

    return customAxiosInstance<UserPreferenceResponse | UserPreferenceResponse>(
      {
        url: `/preferences/set_user_preference`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      },
    );
  };
  /**
 * Sets or updates a user-specific preference value asynchronously. User preferences are individual configuration settings that override organization-level defaults for a specific user account. This is the async version of the preference update endpoint for high-concurrency environments.

**User Preference Overview:**
User preferences are personal configuration overrides that apply only to the authenticated user within their organization. They supersede organization-level preferences, allowing individual customization without affecting other team members.

**Preference Scope and Behavior:**
- **Scope**: User + Organization level (applies only to authenticated user)
- **Priority**: User preferences override organization preferences when both exist
- **Atomicity**: Single key-value update (not batch operation)
- **Async Processing**: Non-blocking async operation for high-concurrency scenarios
- **Audit Trail**: Every preference change is logged with user_id, timestamp, and change details
- **Cache Invalidation**: Automatically clears user-specific preference caches after update
- **Persistence**: Changes persist until explicitly deleted or overwritten

**Supported User Preference Keys:**
- `THEME_PREFERENCE`: UI theme selection (LIGHT, DARK, AUTO)
- `DASHBOARD_LAYOUT`: Dashboard configuration (COMPACT, STANDARD, DETAILED)
- `NOTIFICATION_FREQUENCY`: Notification batching (IMMEDIATE, DAILY, WEEKLY)
- `DEFAULT_ORGANIZATION`: Default org selection on login
- `DOCUMENT_SORT_ORDER`: Document list sorting (NAME_ASC, DATE_DESC, SIZE_ASC)
- `PAGINATION_SIZE`: Items per page (10, 25, 50, 100)
- `EXPORT_FORMAT`: Preferred export format (PDF, XLSX, JSON)
- `TIMEZONE`: User's timezone for date/time display (UTC, Europe/Berlin, etc.)
- `LANGUAGE`: UI language preference (en, de, es, fr, it)
- `AUTO_SUBMIT_THRESHOLD`: Confidence threshold for auto-submission (0-100)

**Parameters:**
- `org_id` (required, Form): Organization UUID where preference is set
  - Must match authenticated user's organization
  - Cannot be overridden; uses user's profile org_id
- `key` (required, Form): Preference key name (case-sensitive)
  - Must match valid user preference key in system
  - Unknown keys may create new custom user preferences
- `value` (optional, Form): Value to set for the preference
  - If empty/null, preference is deleted (reverts to default)
  - Max length: 2000 characters
  - Format depends on key type (string, number, enum)

**Async Behavior:**
- **Non-blocking**: Returns immediately without waiting for database commit
- **Fire-and-Forget Pattern**: Database update happens asynchronously in background
- **Eventual Consistency**: Preference visible on next request (usually < 100ms)
- **Failure Handling**: Exceptions logged but don't block endpoint response
- **Concurrency**: Safe for high-concurrency scenarios (100+ simultaneous updates)
- **Latency**: Typical response time < 50ms (sync version ~ 100-150ms)

**Use Cases:**

1. **User Dashboard Customization**:
   - Save personal dashboard layout preference
   - Remember user's preferred theme (light/dark mode)
   - Client: "User prefers dark theme and compact dashboard layout"

2. **Notification Management**:
   - Allow users to choose notification frequency
   - Save preferred notification channels
   - Client: "User wants daily digest instead of immediate notifications"

3. **Localization Settings**:
   - Store user's language preference
   - Save timezone for date/time display
   - Client: "User in Berlin needs de_DE locale with Europe/Berlin timezone"

4. **High-Performance Update Scenarios**:
   - Bulk updates from UI (multiple preference changes)
   - User interactions during active document processing
   - Client: "Quickly save preference without blocking UI"

5. **A/B Testing and Feature Flags**:
   - Store user's experiment variant assignment
   - Save feature enablement preferences
   - Client: "Store that user is in experiment group 'B' for new UI"

**Cache Behavior:**
- **User Preference Cache**: Cleared after successful update
- **Organization Cache**: NOT affected (user prefs isolated)
- **TTL**: User preference cache refreshed on next request (usually < 100ms)
- **Invalidation Keys**: User:{user_id}:preferences
- **Cascade Effect**: Only user's caches cleared, other users unaffected

**Error Responses:**
- **200 OK**: Preference successfully set or updated
  - Response: `{"success": true, "preference": {"key": "THEME_PREFERENCE", "value": "DARK", "user_id": "abc123...", "org_id": "xyz789...", "created_at": "2024-10-23T14:30:00Z", "updated_at": "2024-10-23T14:35:00Z"}}`
- **400 Bad Request**: Invalid parameters (missing key, malformed org_id, invalid value format)
  - Response: `{"error": "Invalid parameters", "detail": "Preference value exceeds maximum length (2000 chars)"}`
  - Response: `{"error": "Invalid key", "detail": "Preference key must match pattern: ^[A-Z_]+$"}`
- **401 Unauthorized**: User authentication failed or token expired
  - Response: `{"error": "Unauthorized", "detail": "Invalid or missing authentication token"}`
- **403 Forbidden**: User lacks permission to modify their own preferences (extremely rare)
  - Response: `{"error": "Forbidden", "detail": "User not authorized to modify preferences"}`
- **500 Internal Server Error**: Database or async processing error
  - Response: `{"error": "Server Error", "detail": "Failed to update preference asynchronously"}`
  - Response: `{"error": "Service Unavailable", "detail": "Async queue at capacity, try again"}`

**Related Endpoints:**
- `PUT /set_preference` - Update organization-level preference
- `GET /get_preference` - Retrieve single flat preference
- `GET /get_preferences` - Retrieve all organization preferences
- `DELETE /remove_preference` - Delete organization preference

**Example Request:**
```bash
# Set user's theme preference to dark mode
curl -X PUT "https://api.docbits.com/preferences/set_user_preference_async" \
  -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&key=THEME_PREFERENCE&value=DARK"

# Set user's pagination size to 50 items per page
curl -X PUT "https://api.docbits.com/preferences/set_user_preference_async" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&key=PAGINATION_SIZE&value=50"

# Set user's dashboard layout to compact
curl -X PUT "https://api.docbits.com/preferences/set_user_preference_async" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&key=DASHBOARD_LAYOUT&value=COMPACT"
```

**Example Python SDK Usage:**
```python
import asyncio
import aiohttp
from typing import Dict, Any, Optional

class DocBitsAsyncClient:
    def __init__(self, api_url: str, token: str):
        self.api_url = api_url
        self.token = token
        self.headers = {"Authorization": f"Bearer {token}"}

    async def set_user_preference_async(
        self,
        org_id: str,
        key: str,
        value: str
    ) -> Dict[str, Any]:
        """Set user preference asynchronously."""
        data = {
            "org_id": org_id,
            "key": key,
            "value": value
        }

        async with aiohttp.ClientSession() as session:
            async with session.put(
                f"{self.api_url}/preferences/set_user_preference_async",
                data=data,
                headers=self.headers,
                timeout=aiohttp.ClientTimeout(total=10)
            ) as response:
                if response.status == 200:
                    return await response.model_dump_json()
                else:
                    error_data = await response.model_dump_json()
                    raise Exception(f"API Error: {error_data['error']}")

# Usage example
async def main():
    client = DocBitsAsyncClient(
        api_url="https://api.docbits.com",
        token="your_jwt_token"
    )

    org_id = "550e8400-e29b-41d4-a716-446655440000"

    # Set theme preference
    result = await client.set_user_preference_async(
        org_id=org_id,
        key="THEME_PREFERENCE",
        value="DARK"
    )
    logger.debug(f"Theme preference updated: {result['preference']['value']}")

    # Bulk user preferences update (concurrent)
    tasks = [
        client.set_user_preference_async(org_id, "THEME_PREFERENCE", "DARK"),
        client.set_user_preference_async(org_id, "PAGINATION_SIZE", "50"),
        client.set_user_preference_async(org_id, "LANGUAGE", "de"),
        client.set_user_preference_async(org_id, "TIMEZONE", "Europe/Berlin"),
    ]

    results = await asyncio.gather(*tasks)
    for result in results:
        logger.debug(f"Updated {result['preference']['key']} = {result['preference']['value']}")

# Run async example
asyncio.run(main())
```

**Response Format:**
JSON object with preference details and metadata

```json
{
  "success": true,
  "preference": {
    "id": "pref-550e8400-e29b-41d4-a716-446655440000",
    "key": "THEME_PREFERENCE",
    "value": "DARK",
    "user_id": "user-abc123def456",
    "org_id": "550e8400-e29b-41d4-a716-446655440000",
    "created_at": "2024-10-20T10:30:00Z",
    "updated_at": "2024-10-23T14:35:00Z"
  }
}
```

**Performance Notes:**
- Async response time: typically < 50ms
- Synchronous alternative (`/set_preference`): ~100-150ms
- Recommended for high-concurrency UIs and bulk updates
- Safe for 100+ simultaneous requests
- Database writes still happen durably (eventual consistency, not lost)
 * @summary Set or update a user-specific preference asynchronously
 */
  const setUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut = (
    bodySetUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut: BodySetUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodySetUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut.org_id,
    );
    formUrlEncoded.append(
      `key`,
      bodySetUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut.key,
    );
    if (
      bodySetUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut.value !==
      undefined
    ) {
      formUrlEncoded.append(
        `value`,
        bodySetUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut.value,
      );
    }

    return customAxiosInstance<UserPreferenceResponse>({
      url: `/preferences/set_user_preference_async`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Sets or updates a TF-IDF (Term Frequency-Inverse Document Frequency) model preference value for an organization. This endpoint allows configuring ML model parameters, extraction thresholds, and field matching rules specific to TFIDF-based document type classifiers.

**TFIDF Preference Configuration:**
TFIDF preferences store machine learning model configurations at the organization + model level. These settings control how fields are extracted, scored, and matched for specific document types using TF-IDF algorithms.

**Preference Scope and Behavior:**
- **Scope**: Organization + TFIDF Model level (applies to specific ML model configuration)
- **Hierarchy**: org_id → tfidf_id → key → value (nested preference structure)
- **Create or Update**: Automatically creates preference if not exists, updates if exists
- **Supplier-Scoped**: Optional supplier_id field for supplier-specific model variants
- **Atomicity**: Single key-value update (not batch operation)
- **Audit Trail**: Every preference change is logged with user_id, timestamp, and change details
- **Cache Invalidation**: Clears model-specific caches after successful update
- **Persistence**: Changes persist until explicitly deleted

**Supported TFIDF Configuration Keys:**
- `CONFIDENCE_THRESHOLD`: Minimum confidence score for extraction (0-100, e.g., "75")
- `PATTERN_MODE`: Field matching strategy (EXACT, FUZZY, REGEX, HYBRID)
- `FIELD_PRIORITY`: Multi-field extraction priority (HIGH, MEDIUM, LOW, AUTO)
- `FUZZY_MATCHING`: Enable fuzzy/approximate matching (true/false)
- `BATCH_SIZE`: Documents per batch processing (1-1000, e.g., "100")
- `CACHE_TTL`: Model cache validity in seconds (300-86400, e.g., "3600")
- `MIN_OCCURRENCE`: Minimum field occurrence count (0-100, e.g., "2")
- `WEIGHT_ADJUSTMENT`: Score multiplier for specific fields (0.1-10.0, e.g., "1.5")
- `ENABLE_STEMMING`: Enable word stemming in text analysis (true/false)
- `LANGUAGE_MODEL`: Language-specific TF-IDF variant (EN, DE, ES, FR, etc.)

**Parameters:**
- `org_id` (required, Form): Organization UUID where TFIDF model configuration is set
  - Must match authenticated user's organization
  - Cannot be overridden; uses user's profile org_id
- `tfidf_id` (required, Form): Unique identifier of the TFIDF model
  - Format: UUID or semantic model name (e.g., "invoice-extraction-v2")
  - Example: "f47ac10b-58cc-4372-a567-0e02b2c3d479"
  - Must match registered TFIDF model in system
- `key` (required, Form): Configuration key name for TFIDF model (case-sensitive)
  - Must match valid TFIDF configuration key
  - Unknown keys may create new custom TFIDF preferences
  - Pattern: `^[A-Z_]+$` (uppercase with underscores)
- `value` (optional, Form): Value to set for the TFIDF preference
  - If empty/null, preference is deleted
  - Format depends on key type (numeric, boolean, enum string)
  - Max length: 2000 characters
  - Example: "75", "FUZZY", "true", "100"
- `supplier_id` (optional, Form): Supplier UUID for supplier-specific configurations
  - If provided, preference applies only to this supplier
  - If null, preference applies to entire organization
  - Example: "supplier-abc123def456"
  - Allows organization to have supplier-specific TFIDF settings

**Database Behavior:**
- **Create**: If no preference exists for (org_id, tfidf_id, key), creates new record
- **Update**: If preference exists, updates pref_value field
- **Filtering**: Records stored with:
  - `pref_key` = key (case-sensitive, indexed)
  - `tfidf_id` = tfidf_id (indexed)
  - `org_id` = org_id (indexed)
  - `supplier_id` = supplier_id (nullable, indexed)
- **Uniqueness**: Unique constraint on (org_id, tfidf_id, pref_key, supplier_id)
- **Created By**: Automatically set to current user's ID
- **Timestamps**: created_at set on insert, updated_at updated on each change

**Use Cases:**

1. **ML Model Configuration**:
   - Set confidence threshold for document classification
   - Configure field matching patterns for different document types
   - Client: "Set TFIDF confidence to 80% for invoice extraction"

2. **Performance Tuning**:
   - Adjust batch size for bulk processing
   - Configure cache TTL for model inference
   - Client: "Increase batch size from 50 to 200 documents"

3. **Supplier-Specific Models**:
   - Different TFIDF parameters for different suppliers
   - Supplier-specific confidence thresholds
   - Client: "Supplier A uses stricter matching (EXACT), Supplier B uses fuzzy"

4. **A/B Testing Models**:
   - Deploy new TFIDF model variants to subset of suppliers
   - Compare model performance with different configurations
   - Client: "Test new TFIDF v3 model with subset of suppliers"

5. **Language and Region Support**:
   - Set language-specific TFIDF models
   - Configure regional field matching rules
   - Client: "Use German TFIDF model for EU region"

**Cache Behavior:**
- **Model Cache**: Cleared after successful preference update
- **Cache Keys**: tfidf_model:{tfidf_id}:{org_id}
- **Scope**: Organization + TFIDF model specific
- **TTL**: Depends on CACHE_TTL configuration (typically 3600 seconds)
- **Invalidation**: Immediate on preference change

**Error Responses:**
- **200 OK**: TFIDF preference successfully created or updated
  - Response: `{"id": "pref-xyz", "pref_key": "CONFIDENCE_THRESHOLD", "pref_value": "80", "tfidf_id": "invoice-v2", "org_id": "550e8400-...", "supplier_id": null, "created_by": "user-abc", "created_at": "2024-10-20T10:30:00Z", "updated_at": "2024-10-23T14:35:00Z"}`
- **400 Bad Request**: Invalid parameters (missing required fields, invalid format)
  - Response: `{"error": "Invalid parameters", "detail": "tfidf_id is required"}`
  - Response: `{"error": "Invalid key format", "detail": "Key must match pattern: ^[A-Z_]+$"}`
  - Response: `{"error": "Invalid value", "detail": "Confidence threshold must be 0-100"}`
- **401 Unauthorized**: User authentication failed or token expired
  - Response: `{"error": "Unauthorized", "detail": "Invalid or missing authentication token"}`
- **403 Forbidden**: User lacks permission to modify organization preferences
  - Response: `{"error": "Forbidden", "detail": "User not authorized to modify TFIDF preferences"}`
- **404 Not Found**: TFIDF model not registered in system
  - Response: `{"error": "Model Not Found", "detail": "TFIDF model 'unknown-model' not found"}`
- **500 Internal Server Error**: Database error or service failure
  - Response: `{"error": "Server Error", "detail": "Failed to save TFIDF preference"}`

**Related Endpoints:**
- `GET /get_tfidf_preference` - Retrieve single TFIDF preference
- `GET /get_tfidf_preferences_by_org_id` - Fetch all TFIDF preferences for organization
- `DELETE /remove_tfidf_preferences` - Delete TFIDF preference configuration
- `PUT /set_preference` - Update flat organization preference
- `DELETE /remove_preference` - Delete organization preference

**Example Request:**
```bash
# Set confidence threshold for invoice TFIDF model
curl -X PUT "https://api.docbits.com/preferences/set_tfidf_preference" \
  -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&tfidf_id=invoice-extraction-v2&key=CONFIDENCE_THRESHOLD&value=80"

# Set pattern mode for PO extraction with supplier-specific config
curl -X PUT "https://api.docbits.com/preferences/set_tfidf_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&tfidf_id=po-extraction-v1&key=PATTERN_MODE&value=FUZZY&supplier_id=supplier-abc123"

# Enable fuzzy matching for receipt extraction
curl -X PUT "https://api.docbits.com/preferences/set_tfidf_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&tfidf_id=receipt-extraction&key=FUZZY_MATCHING&value=true"

# Set batch size for bulk processing
curl -X PUT "https://api.docbits.com/preferences/set_tfidf_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&tfidf_id=invoice-extraction-v2&key=BATCH_SIZE&value=200"
```

**Example Python SDK Usage:**
```python
import asyncio
import aiohttp
from typing import Dict, Any, Optional

class DocBitsTFIDFClient:
    def __init__(self, api_url: str, token: str):
        self.api_url = api_url
        self.token = token
        self.headers = {"Authorization": f"Bearer {token}"}

    async def set_tfidf_preference(
        self,
        org_id: str,
        tfidf_id: str,
        key: str,
        value: str,
        supplier_id: Optional[str] = None
    ) -> Dict[str, Any]:
        """Set TFIDF model preference configuration."""
        data = {
            "org_id": org_id,
            "tfidf_id": tfidf_id,
            "key": key,
            "value": value
        }
        if supplier_id:
            data["supplier_id"] = supplier_id

        async with aiohttp.ClientSession() as session:
            async with session.put(
                f"{self.api_url}/preferences/set_tfidf_preference",
                data=data,
                headers=self.headers,
                timeout=aiohttp.ClientTimeout(total=10)
            ) as response:
                if response.status == 200:
                    return await response.model_dump_json()
                else:
                    error = await response.model_dump_json()
                    raise Exception(f"API Error: {error['error']} - {error['detail']}")

# Usage example
async def main():
    client = DocBitsTFIDFClient(
        api_url="https://api.docbits.com",
        token="your_jwt_token"
    )

    org_id = "550e8400-e29b-41d4-a716-446655440000"

    # Set invoice model confidence threshold
    result = await client.set_tfidf_preference(
        org_id=org_id,
        tfidf_id="invoice-extraction-v2",
        key="CONFIDENCE_THRESHOLD",
        value="85"
    )
    logger.debug(f"Invoice confidence set to: {result['pref_value']}")

    # Set supplier-specific PO extraction configuration
    result = await client.set_tfidf_preference(
        org_id=org_id,
        tfidf_id="po-extraction-v1",
        key="PATTERN_MODE",
        value="FUZZY",
        supplier_id="supplier-123"
    )
    logger.debug(f"Supplier 123 PO pattern mode: {result['pref_value']}")

    # Bulk configuration update for new model
    configs = [
        ("invoice-extraction-v3", "CONFIDENCE_THRESHOLD", "82"),
        ("invoice-extraction-v3", "FUZZY_MATCHING", "true"),
        ("invoice-extraction-v3", "BATCH_SIZE", "150"),
        ("invoice-extraction-v3", "CACHE_TTL", "7200"),
    ]

    tasks = [
        client.set_tfidf_preference(org_id, tfidf_id, key, value)
        for tfidf_id, key, value in configs
    ]

    results = await asyncio.gather(*tasks)
    for result in results:
        logger.debug(f"Set {result['pref_key']} = {result['pref_value']} for {result['tfidf_id']}")

# Run async example
asyncio.run(main())
```

**Response Format:**
JSON object with TFIDF preference record details

```json
{
  "id": "pref-550e8400-e29b-41d4-a716-446655440000",
  "pref_key": "CONFIDENCE_THRESHOLD",
  "pref_value": "85",
  "tfidf_id": "invoice-extraction-v2",
  "org_id": "550e8400-e29b-41d4-a716-446655440000",
  "supplier_id": null,
  "created_by": "user-abc123def456",
  "created_at": "2024-10-20T10:30:00Z",
  "updated_at": "2024-10-23T14:35:00Z"
}
```

**Supplier-Specific Response Example:**
```json
{
  "id": "pref-550e8400-e29b-41d4-a716-446655440001",
  "pref_key": "PATTERN_MODE",
  "pref_value": "FUZZY",
  "tfidf_id": "po-extraction-v1",
  "org_id": "550e8400-e29b-41d4-a716-446655440000",
  "supplier_id": "supplier-abc123def456",
  "created_by": "user-abc123def456",
  "created_at": "2024-10-21T09:15:00Z",
  "updated_at": "2024-10-23T14:35:00Z"
}
```
 * @summary Set or update a TFIDF model preference configuration
 */
  const setTfidfPreferencePreferencesSetTfidfPreferencePut = (
    bodySetTfidfPreferencePreferencesSetTfidfPreferencePut: BodySetTfidfPreferencePreferencesSetTfidfPreferencePut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodySetTfidfPreferencePreferencesSetTfidfPreferencePut.org_id,
    );
    formUrlEncoded.append(
      `key`,
      bodySetTfidfPreferencePreferencesSetTfidfPreferencePut.key,
    );
    formUrlEncoded.append(
      `tfidf_id`,
      bodySetTfidfPreferencePreferencesSetTfidfPreferencePut.tfidf_id,
    );
    if (
      bodySetTfidfPreferencePreferencesSetTfidfPreferencePut.value !== undefined
    ) {
      formUrlEncoded.append(
        `value`,
        bodySetTfidfPreferencePreferencesSetTfidfPreferencePut.value,
      );
    }
    if (
      bodySetTfidfPreferencePreferencesSetTfidfPreferencePut.supplier_id !==
      undefined
    ) {
      formUrlEncoded.append(
        `supplier_id`,
        bodySetTfidfPreferencePreferencesSetTfidfPreferencePut.supplier_id,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/preferences/set_tfidf_preference`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Retrieves all TF-IDF (Term Frequency-Inverse Document Frequency) model preference configurations for an organization. This endpoint returns a complete view of all TFIDF model settings, extraction thresholds, and field matching rules configured at the organization level.

**Overview:**
This is a bulk retrieval endpoint that fetches all TFIDF preference configurations for an organization at once. It's useful for initializing ML model pipelines, auditing model configurations, and comparing settings across different models.

**Retrieval Scope:**
- **Scope**: Organization-level (retrieves all TFIDF models for organization)
- **Granularity**: Complete list of all (tfidf_id, key, value) tuples
- **Supplier Coverage**: Returns all supplier-specific variants as well as org-wide settings
- **Filtering**: Records retrieved for current user's organization only
- **Consistency**: Consistent point-in-time read from database

**Response Structure:**
Returns an array of TFIDF preference objects, each containing:
- `id`: Unique preference record identifier
- `pref_key`: Configuration key name
- `pref_value`: Configuration value
- `tfidf_id`: TFIDF model identifier
- `org_id`: Organization UUID
- `supplier_id`: Optional supplier UUID (null for org-wide preferences)
- `created_by`: User ID who created the preference
- `created_at`: Timestamp of creation
- `updated_at`: Timestamp of last update

**Use Cases:**

1. **ML Pipeline Initialization**:
   - Load all TFIDF configuration on application startup
   - Populate model caches from database
   - Client: "Initialize all extraction models for this org on startup"

2. **Configuration Audit and Compliance**:
   - Review all TFIDF model settings for compliance
   - Audit model configurations for security/performance
   - Client: "List all ML model configurations for compliance review"

3. **Bulk Configuration Export**:
   - Export current TFIDF settings for backup
   - Prepare configuration for migration to new environment
   - Client: "Get all model settings to export to staging environment"

4. **Model Comparison and Analysis**:
   - Compare configurations across different TFIDF models
   - Analyze which models use fuzzy vs exact matching
   - Client: "Which models have fuzzy matching enabled?"

5. **Performance Optimization**:
   - Review batch sizes and cache TTLs across all models
   - Identify models with suboptimal performance settings
   - Client: "Find all models with cache TTL < 1 hour"

6. **Supplier-Specific Configuration Review**:
   - Review supplier-specific TFIDF overrides
   - Identify suppliers with custom model settings
   - Client: "Which suppliers have custom extraction models?"

**Parameters:**
- `org_id` (required, Query): Organization UUID
  - Must match authenticated user's organization
  - Validates that user has access to organization data
  - Cannot be overridden; uses user's profile org_id

**Response Examples:**

**Organization with Multiple Models and Supplier Variants:**
```json
{
  "success": true,
  "preferences": [
    {
      "id": "pref-001",
      "pref_key": "CONFIDENCE_THRESHOLD",
      "pref_value": "85",
      "tfidf_id": "invoice-extraction-v2",
      "org_id": "550e8400-e29b-41d4-a716-446655440000",
      "supplier_id": null,
      "created_by": "user-abc123",
      "created_at": "2024-10-20T10:30:00Z",
      "updated_at": "2024-10-23T14:35:00Z"
    },
    {
      "id": "pref-002",
      "pref_key": "FUZZY_MATCHING",
      "pref_value": "true",
      "tfidf_id": "invoice-extraction-v2",
      "org_id": "550e8400-e29b-41d4-a716-446655440000",
      "supplier_id": null,
      "created_by": "user-abc123",
      "created_at": "2024-10-20T10:31:00Z",
      "updated_at": "2024-10-20T10:31:00Z"
    },
    {
      "id": "pref-003",
      "pref_key": "CONFIDENCE_THRESHOLD",
      "pref_value": "80",
      "tfidf_id": "invoice-extraction-v2",
      "org_id": "550e8400-e29b-41d4-a716-446655440000",
      "supplier_id": "supplier-abc123",
      "created_by": "user-abc123",
      "created_at": "2024-10-21T09:15:00Z",
      "updated_at": "2024-10-21T09:15:00Z"
    },
    {
      "id": "pref-004",
      "pref_key": "BATCH_SIZE",
      "pref_value": "150",
      "tfidf_id": "po-extraction-v1",
      "org_id": "550e8400-e29b-41d4-a716-446655440000",
      "supplier_id": null,
      "created_by": "user-def456",
      "created_at": "2024-10-22T14:20:00Z",
      "updated_at": "2024-10-22T14:20:00Z"
    }
  ]
}
```

**Empty Response (No TFIDF Preferences Configured):**
```json
{
  "success": true,
  "preferences": []
}
```

**Grouped by Model (Client-Side Processing):**
```json
{
  "success": true,
  "preferences": {
    "invoice-extraction-v2": {
      "org_level": {
        "CONFIDENCE_THRESHOLD": "85",
        "FUZZY_MATCHING": "true",
        "BATCH_SIZE": "100"
      },
      "suppliers": {
        "supplier-abc123": {
          "CONFIDENCE_THRESHOLD": "80"
        },
        "supplier-def456": {
          "PATTERN_MODE": "EXACT"
        }
      }
    },
    "po-extraction-v1": {
      "org_level": {
        "BATCH_SIZE": "150",
        "CACHE_TTL": "3600"
      }
    }
  }
}
```

**Error Responses:**
- **200 OK**: Preferences successfully retrieved
  - Response includes array of preference objects (may be empty if no preferences configured)
  - All models and supplier variants included
- **400 Bad Request**: Invalid organization UUID format
  - Response: `{"error": "Invalid parameter", "detail": "Invalid organization UUID format"}`
- **401 Unauthorized**: User authentication failed or token expired
  - Response: `{"error": "Unauthorized", "detail": "Invalid or missing authentication token"}`
- **403 Forbidden**: User lacks permission to access organization
  - Response: `{"error": "Forbidden", "detail": "User not authorized for this organization"}`
- **404 Not Found**: Organization does not exist (rare)
  - Response: `{"error": "Not Found", "detail": "Organization not found"}`
- **500 Internal Server Error**: Database query error or service failure
  - Response: `{"error": "Server Error", "detail": "Failed to retrieve TFIDF preferences from database"}`

**Related Endpoints:**
- `GET /get_tfidf_preference` - Retrieve single TFIDF preference
- `PUT /set_tfidf_preference` - Create or update TFIDF preference
- `DELETE /remove_tfidf_preferences` - Delete TFIDF preferences for a model
- `GET /get_preferences` - Get flat organization preferences
- `PUT /set_preference` - Update flat organization preference

**Example Request:**
```bash
# Get all TFIDF preferences for organization
curl -X GET "https://api.docbits.com/preferences/get_tfidf_preferences_by_org_id?org_id=550e8400-e29b-41d4-a716-446655440000" \
  -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."

# Get TFIDF preferences for a specific organization (more readable format)
curl -X GET "https://api.docbits.com/preferences/get_tfidf_preferences_by_org_id" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/json" \
  -G --data-urlencode "org_id=550e8400-e29b-41d4-a716-446655440000"
```

**Example Python SDK Usage:**
```python
import asyncio
import aiohttp
from typing import List, Dict, Any, Optional
from dataclasses import dataclass
from datetime import datetime

@dataclass
class TFIDFPreference:
    """TFIDF preference record."""
    id: str
    pref_key: str
    pref_value: str
    tfidf_id: str
    org_id: str
    supplier_id: Optional[str]
    created_by: str
    created_at: str
    updated_at: str

class DocBitsTFIDFBulkClient:
    def __init__(self, api_url: str, token: str):
        self.api_url = api_url
        self.token = token
        self.headers = {"Authorization": f"Bearer {token}"}

    async def get_all_tfidf_preferences(
        self,
        org_id: str
    ) -> List[TFIDFPreference]:
        """Get all TFIDF preferences for organization."""
        params = {"org_id": org_id}

        async with aiohttp.ClientSession() as session:
            async with session.get(
                f"{self.api_url}/preferences/get_tfidf_preferences_by_org_id",
                params=params,
                headers=self.headers,
                timeout=aiohttp.ClientTimeout(total=15)
            ) as response:
                if response.status == 200:
                    data = await response.model_dump_json()
                    return [
                        TFIDFPreference(**pref)
                        for pref in data.get("preferences", [])
                    ]
                elif response.status == 404:
                    logger.debug("Organization not found")
                    return []
                else:
                    error = await response.model_dump_json()
                    raise Exception(f"API Error: {error['error']}")

    async def get_preferences_by_model(
        self,
        org_id: str
    ) -> Dict[str, Dict[str, Any]]:
        """Get TFIDF preferences grouped by model."""
        prefs = await self.get_all_tfidf_preferences(org_id)

        grouped = {}
        for pref in prefs:
            if pref.tfidf_id not in grouped:
                grouped[pref.tfidf_id] = {
                    "org_level": {},
                    "suppliers": {}
                }

            if pref.supplier_id:
                if pref.supplier_id not in grouped[pref.tfidf_id]["suppliers"]:
                    grouped[pref.tfidf_id]["suppliers"][pref.supplier_id] = {}
                grouped[pref.tfidf_id]["suppliers"][pref.supplier_id][pref.pref_key] = pref.pref_value
            else:
                grouped[pref.tfidf_id]["org_level"][pref.pref_key] = pref.pref_value

        return grouped

    async def get_suppliers_with_custom_models(
        self,
        org_id: str
    ) -> Dict[str, List[str]]:
        """Find which suppliers have custom TFIDF configurations."""
        prefs = await self.get_all_tfidf_preferences(org_id)

        suppliers_by_model = {}
        for pref in prefs:
            if pref.supplier_id:
                if pref.tfidf_id not in suppliers_by_model:
                    suppliers_by_model[pref.tfidf_id] = set()
                suppliers_by_model[pref.tfidf_id].add(pref.supplier_id)

        return {
            model: list(suppliers)
            for model, suppliers in suppliers_by_model.items()
            if suppliers
        }

# Usage example
async def main():
    client = DocBitsTFIDFBulkClient(
        api_url="https://api.docbits.com",
        token="your_jwt_token"
    )

    org_id = "550e8400-e29b-41d4-a716-446655440000"

    # Get all preferences
    all_prefs = await client.get_all_tfidf_preferences(org_id)
    logger.debug(f"Total TFIDF preferences: {len(all_prefs)}")
    for pref in all_prefs:
        supplier_info = f" (supplier: {pref.supplier_id})" if pref.supplier_id else " (org-level)"
        logger.debug(f"  {pref.tfidf_id}: {pref.pref_key} = {pref.pref_value}{supplier_info}")

    # Get preferences grouped by model
    grouped = await client.get_preferences_by_model(org_id)
    for model_id, config in grouped.items():
        logger.debug(f"\nModel: {model_id}")
        logger.debug(f"  Organization settings: {config['org_level']}")
        if config['suppliers']:
            logger.debug(f"  Supplier overrides: {config['suppliers']}")

    # Find suppliers with custom configurations
    custom_suppliers = await client.get_suppliers_with_custom_models(org_id)
    for model_id, suppliers in custom_suppliers.items():
        logger.debug(f"{model_id} has custom configs for: {', '.join(suppliers)}")

# Run async example
asyncio.run(main())
```

**Performance Notes:**
- **Typical Response Size**: 100-500 KB (depending on number of TFIDF models and suppliers)
- **Query Complexity**: Single database query with indexes on (org_id, tfidf_id)
- **Response Time**: Typically 100-300ms
- **Cache**: Results not typically cached (configuration data, infrequent changes)
- **Scaling**: Efficient even with 1000+ preferences per organization

**Data Structure Reference:**
Each preference object contains:
- Basic fields: id, pref_key, pref_value
- Model reference: tfidf_id
- Organization reference: org_id
- Supplier scope: supplier_id (nullable)
- Audit: created_by, created_at, updated_at
- No nested objects (flat structure for efficiency)
 * @summary Get all TFIDF model preferences for an organization
 */
  const getTfidfPreferencesByOrgIdPreferencesGetTfidfPreferencesByOrgIdGet = (
    params: GetTfidfPreferencesByOrgIdPreferencesGetTfidfPreferencesByOrgIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/get_tfidf_preferences_by_org_id`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Remove Tfidf Preferences
   */
  const removeTfidfPreferencesPreferencesRemoveTfidfPreferencesDelete = (
    params: RemoveTfidfPreferencesPreferencesRemoveTfidfPreferencesDeleteParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/remove_tfidf_preferences`,
      method: 'DELETE',
      params,
    });
  };
  /**
 * Removes (soft-deletes) an organization-level preference, reverting that setting to its system default value. This is the primary method for removing custom preference overrides.

**Deletion Behavior:**
- **Type**: Soft-delete (marked `is_deleted = true`, not physically removed)
- **Scope**: Organization-level preference (applies to entire organization)
- **Effect**: Setting reverts to system default on next access
- **Audit Trail**: Deletion is logged for compliance and debugging
- **Recovery**: Soft-delete allows data recovery if needed
- **Cache**: Automatically cleared after deletion

**Key Characteristics:**
- **Organization-scoped**: Only organization preferences (user_id = NULL)
- **Permanent Effect**: Preference removed until re-created
- **Default Reversion**: Setting returns to system default
- **Cascade**: Dashboard/extraction cache cleared if related
- **Non-destructive**: Data preserved in database (soft-delete)

**Parameters:**
- `org_id` (required, Query): Organization UUID
  - Must match authenticated user's organization
  - Determines which organization preference is deleted
  - Case-sensitive UUID format
- `key` (required, Query): Preference key name
  - Case-sensitive key identifier
  - Examples: "DOCUMENT_TIMEOUT", "ENABLE_FUZZY_MATCHING", etc.
  - Must match existing preference key in database
- User authentication required via Bearer token

**Response on Success:**
```json
{
  "success": true,
  "message": "Preference removed successfully."
}
```

**Response on Not Found:**
```json
{
  "success": false,
  "message": "No preferences record found."
}
```

**Response on Error:**
```json
{
  "success": false,
  "message": "An Error occurred. Message: database connection error"
}
```

**Database Behavior:**
1. Queries database for preference record
2. Filters on: user_id = NULL (organization preference), org_id, and key
3. If found: sets `is_deleted = true` and saves
4. If not found: returns success: false

**Cache Invalidation:**
- Clears `preferences` cache for organization
- Clears `preferences` cache for authenticated user
- Forces fresh data fetch from database on next request

**Activity Logging:**
- Log Type: `org-preference`
- Message: `User deleted org {key}`
- Records: org_id, user_id, timestamp, preference key

**Error Responses:**
- 200: Preference successfully deleted (or not found)
- 400: Invalid preference key format or missing parameters
- 401: User authentication failed
- 403: User lacks permission for organization
- 500: Database error during deletion or cache clearing
  - Returns `success: false` in response body

**Use Cases:**
1. **Reset to Default**: Remove custom value to use system default
2. **Configuration Cleanup**: Remove unused preferences
3. **Mistake Correction**: Delete incorrectly set preferences
4. **Feature Disable**: Remove feature flag (returns to default)
5. **Migration**: Clean up old preferences during system upgrade

**Difference from `/set_preference`:**
- `/set_preference`: Update preference to new value
- `/remove_preference`: Delete preference (revert to default) ← THIS ENDPOINT
- Effect: Setting resets to system default value

**Related Endpoints:**
- `GET /get_preference`: Retrieve single preference value
- `GET /get_preferences`: Retrieve all preferences
- `PUT /set_preference`: Update preference value
- `PUT /set_preferences`: Batch update multiple preferences
- `DELETE /delete_cache_for_org`: Clear all cache (related cleanup)

**Important Note:**
Code comment indicates cache clearing happens AFTER preference deletion, which may create a brief window where stale cache is present. This is acceptable as next request will trigger fresh fetch.

**Example Requests:**

Remove document timeout preference:
```bash
curl -X DELETE "https://api.docbits.com/preferences/remove_preference?org_id=org-uuid-12345&key=DOCUMENT_TIMEOUT" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN"
```

Remove fuzzy matching toggle:
```bash
curl -X DELETE "https://api.docbits.com/preferences/remove_preference?org_id=org-uuid-12345&key=ENABLE_FUZZY_MATCHING" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN"
```

Python example with error handling:
```python
import requests

response = requests.delete(
    "https://api.docbits.com/preferences/remove_preference",
    params={
        "org_id": org_uuid,
        "key": "DOCUMENT_TIMEOUT"
    },
    headers={"Authorization": f"Bearer {token}"}
)

result = response.model_dump_json()
if result["success"]:
    logger.debug(f"Preference deleted: {result['message']}")
else:
    logger.debug(f"Deletion failed: {result['message']}")
```

**Important Notes:**
- Soft-delete preserves audit trail (GDPR compliant)
- Cache clearing happens synchronously (blocking operation)
- User must be authenticated and authorized
- Preference key must exist (no error if already deleted)
- Setting reverts to system default immediately
 * @summary Delete an organization-level preference
 */
  const removePreferencePreferencesRemovePreferenceDelete = (
    params: RemovePreferencePreferencesRemovePreferenceDeleteParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/remove_preference`,
      method: 'DELETE',
      params,
    });
  };
  /**
 * Deletes a user-specific preference for the authenticated user.

    **Effect:** The preference is soft-deleted (marked as deleted, not removed from DB).

    **Cache Clearing:** Cache is automatically cleared after deletion.

    **User Isolation:** Deleting one user's preference does NOT affect other users' preferences.
 * @summary Remove user preference
 */
  const removeUserPreferencePreferencesRemoveUserPreferenceDelete = (
    bodyRemoveUserPreferencePreferencesRemoveUserPreferenceDelete: BodyRemoveUserPreferencePreferencesRemoveUserPreferenceDelete,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyRemoveUserPreferencePreferencesRemoveUserPreferenceDelete.org_id,
    );
    formUrlEncoded.append(
      `key`,
      bodyRemoveUserPreferencePreferencesRemoveUserPreferenceDelete.key,
    );

    return customAxiosInstance<SuccessResponse>({
      url: `/preferences/remove_user_preference`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Retrieves a mapping of supported barcode formats that can be used for document splitting and data extraction. This endpoint returns barcode codes and their human-readable format names.

**Supported Barcode Formats:**
The system supports 21 barcode types across multiple encoding standards:
- **1D Barcodes**: CODE39, CODE93, CODE128, I25, CODABAR
- **EAN/UPC**: EAN2, EAN5, EAN8, EAN13, UPCA, UPCE
- **ISBN**: ISBN10, ISBN13
- **2D Barcodes**: QRCODE, SQCODE, PDF417, DATABAR, DATABAR-EXP, COMPOSITE

**Use Cases:**

1. **Document Splitting**: Split multi-document uploads by barcode separator pages
2. **Field Extraction**: Extract barcode data as document metadata
3. **Batch Processing**: Route documents based on barcode prefixes
4. **Supplier Identification**: Use barcodes to identify document source/supplier
5. **Version Control**: Track document versions via barcode sequences

**Response Format:**
Returns a flat dictionary mapping barcode codes (keys) to human-readable names (values).

**Error Responses:**
- **200 OK**: Barcode types successfully retrieved
- **401 Unauthorized**: User authentication failed

**Related Endpoints:**
- Barcode splitting preferences (future endpoints)
- Document classification by barcode

**Example Request:**
```bash
curl -X GET "https://api.docbits.com/preferences/get_supported_barcode_types" \
  -H "Authorization: Bearer YOUR_TOKEN"
```

**Example Python SDK:**
```python
import requests

client = requests.get(
    "https://api.docbits.com/preferences/get_supported_barcode_types",
    headers={"Authorization": f"Bearer {token}"}
)
barcode_types = client.model_dump_json()
for code, name in barcode_types.items():
    logger.debug(f"{code}: {name}")  # e.g., "QRCODE: QR-CODE"
```

**Response Example:**
```json
{
  "QRCODE": "QR-CODE",
  "CODE128": "CODE-128",
  "CODE39": "CODE-39",
  "EAN13": "EAN-13",
  "UPCA": "UPC-A",
  ...
}
```
 * @summary Get list of supported barcode format types
 */
  const getSupportedBarcodeTypesPreferencesGetSupportedBarcodeTypesGet = () => {
    return customAxiosInstance<unknown>({
      url: `/preferences/get_supported_barcode_types`,
      method: 'GET',
    });
  };
  /**
 * Updates organization-level preferences using a hierarchical nested key structure (main_key and optional sub_key). This endpoint allows setting both boolean and string values for complex preference configurations stored in the generic data vault.

**Preference Structure:**
This endpoint uses a nested preference hierarchy:
- **main_key** (required): Primary configuration category (e.g., "EXTRACTION", "VALIDATION")
- **sub_key** (optional): Specific setting within the category (e.g., "CONFIDENCE_THRESHOLD")
- **bool_value_1** (optional): Boolean value for toggle preferences (true/false)
- **str_value_1** (optional): String value for text-based preferences

**Behavior:**
- **Type**: Generic Data Vault (GDV) preference update
- **Scope**: Organization-wide (applies to entire organization)
- **Value Types**: Supports boolean toggles OR string configurations (not both simultaneously)
- **Cache**: Automatically clears both organization and user-level preference caches
- **Audit**: All changes logged with user_id, timestamp, and change details
- **Atomicity**: Single atomic update operation

**Parameters:**
- `org_id` (required, Form): Organization UUID
  - Must match authenticated user's organization
- `main_key` (required, Form): Primary preference category name
  - Examples: "EXTRACTION", "VALIDATION", "INTEGRATION", "STORAGE"
  - Case-sensitive
- `sub_key` (optional, Form): Nested preference key
  - Refines the main_key setting to specific feature/field
  - Examples: "CONFIDENCE_THRESHOLD", "TIMEOUT", "ENABLED"
  - If omitted, updates entire main_key category
- `bool_value_1` (optional, Form): Boolean toggle value (true or false)
  - Used for feature toggles and binary settings
  - Mutually exclusive with str_value_1
- `str_value_1` (optional, Form): String configuration value
  - Used for text-based settings (modes, names, paths)
  - Mutually exclusive with bool_value_1

**Use Cases:**

1. **Feature Configuration**: Update extraction confidence threshold per supplier
2. **Boolean Toggles**: Enable/disable specific validation rules
3. **Multi-Level Settings**: Organize complex configurations by category
4. **Generic Preferences**: Store custom application settings
5. **Compliance Configuration**: Set organization-specific compliance options

**Cache Behavior:**
- Both `preferences:{org_id}` and `preferences:{user_id}` caches cleared
- Next API call fetches fresh preference from database
- Immediate consistency across all API instances

**Response Behavior:**
- **Success (200 OK)**: Preference updated and caches cleared
  - Response: `{"success": true, "message": "Preference saved successfully"}`
  - Both organization and user caches have been invalidated
  - Change has been logged to activity trail

**Error Responses:**
- **200 OK**: Preference successfully updated
- **400 Bad Request**: Invalid parameters (missing main_key, invalid data types)
- **401 Unauthorized**: User authentication failed
- **403 Forbidden**: User lacks permission for organization
- **500 Internal Server Error**: Database update or cache clearing failed

**Related Endpoints:**
- `POST /get_organisation_preference` - Retrieve hierarchical preferences
- `PUT /set_preference` - Update flat organization preferences
- `GET /get_preferences` - Retrieve all flat preferences

**Example Request:**
```bash
# Update extraction confidence threshold (boolean)
curl -X POST "https://api.docbits.com/preferences/update_organisation_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&main_key=EXTRACTION&sub_key=CONFIDENCE_THRESHOLD&bool_value_1=true"

# Update extraction mode (string value)
curl -X POST "https://api.docbits.com/preferences/update_organisation_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&main_key=EXTRACTION&sub_key=MODE&str_value_1=FUZZY"

# Update entire category (no sub_key)
curl -X POST "https://api.docbits.com/preferences/update_organisation_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&main_key=VALIDATION&bool_value_1=true"
```

**Example Python SDK:**
```python
import requests

class DocBitsNestedPrefsClient:
    def __init__(self, api_url: str, token: str):
        self.api_url = api_url
        self.headers = {"Authorization": f"Bearer {token}"}

    def update_preference(self, org_id: str, main_key: str,
                         sub_key=None, bool_val=None, str_val=None):
        """Update hierarchical organization preference."""
        data = {
            "org_id": org_id,
            "main_key": main_key,
        }
        if sub_key:
            data["sub_key"] = sub_key
        if bool_val is not None:
            data["bool_value_1"] = str(bool_val).lower()
        if str_val:
            data["str_value_1"] = str_val

        response = requests.post(
            f"{self.api_url}/preferences/update_organisation_preference",
            data=data,
            headers=self.headers,
            timeout=10
        )
        return response.model_dump_json()

# Usage
client = DocBitsNestedPrefsClient("https://api.docbits.com", "token")

result = client.update_preference(
    org_id="550e8400-...",
    main_key="EXTRACTION",
    sub_key="CONFIDENCE_THRESHOLD",
    bool_val=True
)
logger.debug(f"Updated: {result['message']}")
```

**Data Storage:**
Preferences are stored in the Generic Data Vault (GDV) with the following structure:
- Table: `generic_data_vault`
- Fields: `main_key`, `sub_key`, `bool_value_1`, `str_value_1`, org_id, user_id
- Primary Key: (org_id, main_key, sub_key, user_id)
- Storage: Persistent across sessions and API restarts

**Performance Notes:**
- Cache clear operations: < 10ms
- Database update: 50-100ms
- Activity logging: < 5ms
- Total operation: typically < 200ms
 * @summary Update hierarchical organization preference with nested keys
 */
  const updateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost =
    (
      bodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost: BodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost,
    ) => {
      const formUrlEncoded = new URLSearchParams();
      formUrlEncoded.append(
        `org_id`,
        bodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost.org_id,
      );
      formUrlEncoded.append(
        `main_key`,
        bodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost.main_key,
      );
      if (
        bodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost.sub_key !==
        undefined
      ) {
        formUrlEncoded.append(
          `sub_key`,
          bodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost.sub_key,
        );
      }
      if (
        bodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost.bool_value_1 !==
        undefined
      ) {
        formUrlEncoded.append(
          `bool_value_1`,
          bodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost.bool_value_1.toString(),
        );
      }
      if (
        bodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost.str_value_1 !==
        undefined
      ) {
        formUrlEncoded.append(
          `str_value_1`,
          bodyUpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost.str_value_1,
        );
      }

      return customAxiosInstance<unknown>({
        url: `/preferences/update_organisation_preference`,
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      });
    };
  /**
 * Retrieves organization-level preferences using a hierarchical key structure (main_key and optional sub_key). This endpoint is for nested/hierarchical preference configurations.

**Key Structure:**
This endpoint supports a nested preference hierarchy:
- **main_key** (required): Primary configuration category
  - Examples: "EXTRACTION", "VALIDATION", "INTEGRATION", "STORAGE", "ERP"
  - Groups related settings under a main category
- **sub_key** (optional): Specific setting within the category
  - Examples: "CONFIDENCE_THRESHOLD", "TIMEOUT", "ENABLED", "MODE"
  - Allows fine-grained configuration of specific features
  - If omitted, retrieves all sub-keys for the main category

**Hierarchical Examples:**
- main_key="EXTRACTION", sub_key="CONFIDENCE_THRESHOLD" → extraction confidence setting
- main_key="EXTRACTION", sub_key="FUZZY_MATCHING" → fuzzy matching toggle
- main_key="INTEGRATION", sub_key="ERP_MODE" → ERP system mode
- main_key="VALIDATION", sub_key="STRICTNESS" → validation strictness level
- main_key="STORAGE" (no sub_key) → all storage-related settings

**Parameters:**
- `org_id` (required, Form): Organization UUID
  - Must match authenticated user's organization
  - Uses user's profile org_id (cannot be overridden)
- `main_key` (required, Form): Primary configuration key
  - Case-sensitive category name
  - Examples: "EXTRACTION", "VALIDATION", "INTEGRATION"
- `sub_key` (optional, Form): Nested configuration key
  - Case-sensitive specific setting name
  - If omitted, all values for main_key are returned
  - Examples: "CONFIDENCE_THRESHOLD", "TIMEOUT", "ENABLED"

**Response - With sub_key:**
```json
{
  "success": true,
  "value": "85",
  "main_key": "EXTRACTION",
  "sub_key": "CONFIDENCE_THRESHOLD",
  "org_id": "org-uuid-12345",
  "configured_at": "2024-10-23T10:30:00Z"
}
```

**Response - Without sub_key (all values in category):**
```json
{
  "success": true,
  "values": {
    "CONFIDENCE_THRESHOLD": "85",
    "FUZZY_MATCHING": "true",
    "OCR_ENGINE": "DocumentAI",
    "TIMEOUT": "300"
  },
  "main_key": "EXTRACTION",
  "org_id": "org-uuid-12345"
}
```

**Default Values:**
- If preference not set, returns default value of `false`
- No error is raised for missing preferences
- Null/empty values are handled gracefully

**Response Format:**
- Plain text or JSON depending on configuration
- Caching currently disabled (see code comment)
- Real-time response from database

**Error Responses:**
- 200: Preference retrieved successfully (or returns default)
- 400: Invalid main_key or sub_key format
- 401: User authentication failed
- 403: User lacks permission for organization
- 404: Organization not found
- 500: Database query error

**Use Cases:**
1. **Extraction Settings**: Retrieve confidence thresholds, fuzzy matching flags
2. **Validation Configuration**: Get strictness levels for field validation
3. **Integration Settings**: Retrieve ERP mode, API keys, connection settings
4. **Storage Configuration**: Get bucket names, retention policies
5. **Feature Toggles**: Check if specific features are enabled by category

**Difference from `/get_preference`:**
- `/get_preference`: Flat key-value lookup (single string key)
- `/get_organisation_preference`: Hierarchical lookup (main_key + optional sub_key) ← THIS ENDPOINT
- Allows grouping related settings under categories

**Example Requests:**

Get specific extraction confidence threshold:
```bash
curl -X POST "https://api.docbits.com/preferences/get_organisation_preference" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=org-uuid-12345&main_key=EXTRACTION&sub_key=CONFIDENCE_THRESHOLD"
```

Get all extraction settings (omit sub_key):
```bash
curl -X POST "https://api.docbits.com/preferences/get_organisation_preference" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=org-uuid-12345&main_key=EXTRACTION"
```

Get integration ERP mode:
```bash
curl -X POST "https://api.docbits.com/preferences/get_organisation_preference" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=org-uuid-12345&main_key=INTEGRATION&sub_key=ERP_MODE"
```

**Notes:**
- HTTP Method: POST (even though it's a read operation)
- Caching: Disabled per code comment (could be optimized with TTL=3600)
- Response: May vary depending on whether sub_key is provided
- Default Value: Returns `false` if preference not found (graceful degradation)
 * @summary Get nested organization preference with main and sub keys
 */
  const getOrganisationPreferencePreferencesGetOrganisationPreferencePost = (
    bodyGetOrganisationPreferencePreferencesGetOrganisationPreferencePost: BodyGetOrganisationPreferencePreferencesGetOrganisationPreferencePost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyGetOrganisationPreferencePreferencesGetOrganisationPreferencePost.org_id,
    );
    formUrlEncoded.append(
      `main_key`,
      bodyGetOrganisationPreferencePreferencesGetOrganisationPreferencePost.main_key,
    );
    if (
      bodyGetOrganisationPreferencePreferencesGetOrganisationPreferencePost.sub_key !==
      undefined
    ) {
      formUrlEncoded.append(
        `sub_key`,
        bodyGetOrganisationPreferencePreferencesGetOrganisationPreferencePost.sub_key,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/preferences/get_organisation_preference`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Retrieves regular expression patterns used for extracting and validating specific document types. Regex patterns are used to match, extract, and validate field values during document processing.

**Regex Pattern Types:**

Regex patterns enable flexible extraction from documents by defining:
- **Pattern Matching**: Extract values matching specific patterns (e.g., invoice numbers)
- **Field Validation**: Validate extracted values against expected format
- **Multi-format Support**: Handle documents with varying formats
- **Conditional Extraction**: Extract based on document layout or content

**Common Regex Types** (regexType parameter):
- `INVOICE_NUMBER`: Pattern for invoice number extraction (e.g., `INV-\d{6}`)
- `PO_NUMBER`: Pattern for purchase order numbers (e.g., `PO-\d{8}`)
- `DATE`: Date pattern matching (e.g., `\d{2}/\d{2}/\d{4}`)
- `AMOUNT`: Currency/amount pattern (e.g., `\d+\.\d{2}`)
- `CURRENCY_CODE`: Currency code pattern (e.g., `[A-Z]{3}`)
- `ACCOUNT_NUMBER`: Account number pattern
- `VENDOR_ID`: Vendor identifier pattern
- `LINE_ITEM_PATTERN`: Extract line items from documents

**Regex Configuration:**
Each regex pattern includes:
- **regexOrigin**: System or user-defined (origin marker)
- **regexKeyPattern**: Pattern for matching field keys/names
- **regexValuePattern**: Pattern for extracting field values
- **regexDirection**: Direction of matching (forward, backward, both)
- **sort_order**: Priority order for applying multiple regexes
- **disabled**: Whether pattern is currently disabled for extraction

**Parameters:**
- `org_id` (required, Form): Organization UUID
  - Must match authenticated user's organization
  - Patterns are org-specific (custom per organization)
- `data` (required, Form): JSON string with configuration
  - Must include `regexType` key (the pattern type to retrieve)
  - Format: `{"regexType": "INVOICE_NUMBER"}`
  - Supported types: INVOICE_NUMBER, PO_NUMBER, DATE, AMOUNT, etc.

**Response:**
```json
[
  {
    "id": "550e8400-e29b-41d4-a716-446655440000",
    "regexOrigin": "system",
    "regexType": "INVOICE_NUMBER",
    "regexKeyPattern": "inv|invoice|#",
    "regexValuePattern": "INV-\d{6}",
    "regexDirection": "forward",
    "sort_order": 1,
    "user_id": 1001,
    "org_id": "org-uuid-12345",
    "disabled": false
  },
  {
    "id": "660e8400-e29b-41d4-a716-446655440001",
    "regexOrigin": "user",
    "regexType": "INVOICE_NUMBER",
    "regexKeyPattern": "document.number",
    "regexValuePattern": "DOC-\d{8}",
    "regexDirection": "backward",
    "sort_order": 2,
    "user_id": 1001,
    "org_id": "org-uuid-12345",
    "disabled": false
  }
]
```

**Pattern Hierarchy:**
- Patterns can be **system-defined** (provided by DocBits) or **user-defined** (custom)
- User patterns take precedence over system patterns
- Sort order determines evaluation priority (lower number = higher priority)
- Disabled patterns are skipped during extraction

**Cascade Logic:**
- System patterns retrieved for DEFAULT_ORG_UUID (default docbits patterns)
- User patterns retrieved for authenticated user's organization
- Both are returned together, allowing custom overrides of system patterns
- Org-level and user-level patterns are merged in response

**Cache Behavior:**
- Caching disabled per code comment (could be optimized with TTL=300)
- Returns fresh patterns from database each request
- Cached key would be: `document_type:{org_id}:{regexType}`

**Error Responses:**
- 200: Patterns retrieved successfully (may be empty list if none exist)
- 400: Invalid JSON format in `data` parameter
- 401: User authentication failed
- 403: User lacks permission for organization
- 500: Database query error or exception
  - Returns `False` on error (non-standard error response)

**Use Cases:**
1. **Invoice Processing**: Retrieve invoice number extraction patterns
2. **PO Extraction**: Get purchase order number patterns
3. **Multi-format Support**: Handle documents with varying formats
4. **Field Validation**: Validate extracted values against patterns
5. **Custom Extraction**: Use organization-specific extraction rules

**Related Operations:**
- Document type field configuration (defines which fields apply patterns)
- Field extraction pipeline (uses these patterns during processing)
- Validation rules (apply patterns to validate extracted data)

**Example Requests:**

Get invoice number extraction patterns:
```bash
curl -X POST "https://api.docbits.com/preferences/get_document_type_regexes" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d 'org_id=org-uuid-12345&data={"regexType":"INVOICE_NUMBER"}'
```

Get purchase order patterns:
```bash
curl -X POST "https://api.docbits.com/preferences/get_document_type_regexes" \
  -H "Authorization: Bearer YOUR_JWT_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d 'org_id=org-uuid-12345&data={"regexType":"PO_NUMBER"}'
```

Get date extraction patterns (Python):
```python
import requests
import json

response = requests.post(
    "https://api.docbits.com/preferences/get_document_type_regexes",
    headers={"Authorization": f"Bearer {token}"},
    data={
        "org_id": org_uuid,
        "data": json.dumps({"regexType": "DATE"})
    }
)

patterns = response.model_dump_json()
for pattern in patterns:
    logger.debug(f"Pattern: {pattern['regexValuePattern']}")
    logger.debug(f"Priority: {pattern['sort_order']}")
    logger.debug(f"Disabled: {pattern['disabled']}")
```

**Important Notes:**
- HTTP Method: POST (even though it's a read operation)
- Caching: Currently disabled but could be optimized
- Error Handling: Returns `False` on exception (non-standard)
- Async: Uses `async def` for database query execution
 * @summary Get document type regex patterns for extraction
 */
  const getDocumentTypeRegexesPreferencesGetDocumentTypeRegexesPost = (
    bodyGetDocumentTypeRegexesPreferencesGetDocumentTypeRegexesPost: BodyGetDocumentTypeRegexesPreferencesGetDocumentTypeRegexesPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyGetDocumentTypeRegexesPreferencesGetDocumentTypeRegexesPost.org_id,
    );
    formUrlEncoded.append(
      `data`,
      bodyGetDocumentTypeRegexesPreferencesGetDocumentTypeRegexesPost.data,
    );

    return customAxiosInstance<unknown>({
      url: `/preferences/get_document_type_regexes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Sets the dashboard data aggregation feature toggle for an organization. This endpoint controls whether documents are automatically grouped and aggregated for dashboard display, affecting data warehouse behavior and storage requirements.

**Feature Overview:**
The dashboard grouping preference controls whether the system maintains aggregated views of document data for dashboard visualization. When enabled, the system continuously updates aggregated summaries for faster dashboard queries. When disabled, aggregated data is removed to save storage and processing resources.

**Preference Behavior:**
- **Preference Key**: GROUPING_DASHBOARD
- **Valid Values**: "true" (enable) or "false" (disable)
- **Scope**: Organization-wide (affects all dashboard views)
- **Side Effects**: Enables/disables automatic data aggregation in warehouse
- **Storage Impact**: Disabling frees storage by removing aggregated data
- **Query Performance**: Enabled = faster dashboards, Disabled = slower ad-hoc queries
- **Audit Trail**: Change is logged with timestamp and user information

**Data Warehouse Integration:**
When toggled, this preference triggers warehouse operations:
- **Enable (value="true")**:
  - Inserts aggregated records into dashboard table
  - Initializes dimension aggregations (org, document_type, status, date)
  - Starts background aggregation jobs
  - Enables fast dashboard queries (typically 100-500ms)

- **Disable (value="false")**:
  - Deletes all aggregated records for organization
  - Optimizes dashboard table (reclaims storage)
  - Stops background aggregation jobs
  - Saves 20-50% warehouse storage (depending on document volume)
  - Dashboard queries revert to slower on-demand calculation (5-30 seconds)

**Parameters:**
- `org_id` (required, Form): Organization UUID
  - Must match authenticated user's organization
  - Cannot be overridden; uses user's profile org_id
- `key` (required, Form): Configuration key (must be "GROUPING_DASHBOARD")
  - Case-sensitive, exact match required
  - Other keys may be supported for future extensions
- `value` (optional, Form): Feature toggle value
  - "true" = Enable dashboard aggregation
  - "false" = Disable dashboard aggregation
  - NULL/empty = Toggle off (same as "false")

**Use Cases:**

1. **Storage Optimization**:
   - Disable grouping for demo/test organizations
   - Reduce warehouse storage costs
   - Client: "Disable dashboard aggregation to save 30GB per month"

2. **Performance Tuning**:
   - Enable for production organizations with heavy dashboard usage
   - Maintain fast dashboard load times (< 500ms)
   - Client: "Enable grouping for faster dashboard queries"

3. **New Organization Onboarding**:
   - Start with disabled grouping, enable after pilot
   - Test without storage overhead
   - Client: "Keep disabled during 30-day trial, enable after commitment"

4. **Storage Pressure Management**:
   - Disable grouping when warehouse exceeds 80% capacity
   - Re-enable after cleanup/archival
   - Client: "Disable grouping temporarily until we archive old documents"

5. **Feature Rollout**:
   - Enable for subset of organizations during beta
   - Gradually roll out aggregation feature
   - Client: "Enable grouping for 20% of customers to test performance"

**Response Behavior:**
- **Success (200 OK)**:
  - If value="true": Returns preference record with confirmation
    - Response: `{"success": true, "data": {preference_object}}`
    - Dashboard data aggregation has been enabled
    - Aggregation jobs will start running in background

  - If value="false": Returns success message with deletion confirmation
    - Response: `{"success": true, "message": "Row count is zero data has deleted"}`
    - All aggregated dashboard records have been deleted
    - Storage has been freed and table optimized
    - Dashboard queries will be slower until re-enabled

- **Partial Success (202 Accepted)**:
  - Database preference updated but warehouse operation still in progress
  - Recommend waiting 30-60 seconds before checking status
  - Dashboard may show partial data during aggregation

- **Error (400/500)**:
  - Preference not updated, no warehouse changes made
  - Response: `{"success": false, "message": "An error occurred while setting preference."}`
  - Customer should retry or contact support

**Side Effects and Data Consistency:**

- **When Enabling**:
  - Background job inserts aggregated records (may take 5-30 minutes for large orgs)
  - Dashboard queries may return incomplete results during aggregation
  - Performance gradually improves as aggregation completes

- **When Disabling**:
  - All aggregated records deleted immediately
  - Storage reclaimed after table optimization (< 1 minute)
  - Dashboard queries will use on-demand calculation (slower)
  - No data loss - source documents remain untouched

**Error Responses:**
- **200 OK**: Preference successfully set and warehouse operation completed
  - Response includes success confirmation and operation details
- **400 Bad Request**: Invalid parameters (invalid value, missing key)
  - Response: `{"error": "Invalid value", "detail": "Value must be 'true' or 'false'"}`
- **401 Unauthorized**: User authentication failed
  - Response: `{"error": "Unauthorized", "detail": "Invalid authentication token"}`
- **403 Forbidden**: User lacks permission to modify organization preferences
  - Response: `{"error": "Forbidden", "detail": "User not authorized for this organization"}`
- **500 Internal Server Error**: Database or warehouse operation failure
  - Response: `{"success": false, "message": "An error occurred while setting preference."}`

**Related Endpoints:**
- `PUT /set_reporting_engine_preference` - Enable/disable warehouse reporting
- `PUT /set_grouping_purchase_order_preference` - Toggle PO aggregation
- `PUT /set_preference` - Update flat organization preference
- `GET /get_preferences` - Retrieve all organization preferences

**Example Request:**
```bash
# Enable dashboard grouping and aggregation
curl -X PUT "https://api.docbits.com/preferences/set_grouping_dashboard_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&key=GROUPING_DASHBOARD&value=true"

# Disable dashboard grouping to save storage
curl -X PUT "https://api.docbits.com/preferences/set_grouping_dashboard_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&key=GROUPING_DASHBOARD&value=false"
```

**Example Python SDK Usage:**
```python
import asyncio
import requests
from typing import Dict, Any

class DocBitsFeatureToggleClient:
    def __init__(self, api_url: str, token: str):
        self.api_url = api_url
        self.token = token
        self.headers = {"Authorization": f"Bearer {token}"}

    def set_dashboard_grouping(
        self,
        org_id: str,
        enable: bool
    ) -> Dict[str, Any]:
        """Enable or disable dashboard data aggregation."""
        data = {
            "org_id": org_id,
            "key": "GROUPING_DASHBOARD",
            "value": "true" if enable else "false"
        }

        response = requests.put(
            f"{self.api_url}/preferences/set_grouping_dashboard_preference",
            data=data,
            headers=self.headers,
            timeout=30  # May take time for large aggregations
        )

        if response.status_code == 200:
            return response.model_dump_json()
        else:
            raise Exception(f"API Error: {response.text}")

# Usage example
client = DocBitsFeatureToggleClient(
    api_url="https://api.docbits.com",
    token="your_jwt_token"
)

org_id = "550e8400-e29b-41d4-a716-446655440000"

# Enable dashboard grouping for production org
result = client.set_dashboard_grouping(org_id, enable=True)
logger.debug(f"Dashboard grouping enabled: {result['success']}")

# Disable grouping for storage optimization
result = client.set_dashboard_grouping(org_id, enable=False)
logger.debug(f"Dashboard grouping disabled: {result['success']}")
if 'message' in result:
    logger.debug(f"Status: {result['message']}")  # "Row count is zero data has deleted"
```

**Performance Notes:**
- **Enable Operation**: 5-30 minutes depending on organization data volume
  - Small orgs (< 100k docs): ~5 minutes
  - Medium orgs (100k-1M docs): ~15 minutes
  - Large orgs (> 1M docs): 20-30 minutes

- **Disable Operation**: 30 seconds to 2 minutes
  - Deletes aggregated records (fast)
  - Table optimization (variable based on table size)
  - Storage reclaimed immediately after optimization

- **Dashboard Query Times**:
  - With grouping enabled: 100-500ms (pre-aggregated)
  - With grouping disabled: 5-30 seconds (on-demand calculation)
 * @summary Enable or disable dashboard data aggregation and grouping
 */
  const setGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut =
    (
      bodySetGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut: BodySetGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut,
    ) => {
      const formUrlEncoded = new URLSearchParams();
      formUrlEncoded.append(
        `org_id`,
        bodySetGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut.org_id,
      );
      formUrlEncoded.append(
        `key`,
        bodySetGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut.key,
      );
      if (
        bodySetGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut.value !==
        undefined
      ) {
        formUrlEncoded.append(
          `value`,
          bodySetGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut.value,
        );
      }

      return customAxiosInstance<unknown>({
        url: `/preferences/set_grouping_dashboard_preference`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      });
    };
  /**
 * Enables or disables the warehouse reporting engine for an organization. When enabled, the system creates database credentials and user accounts for warehouse reporting. When disabled, reporting access is removed and database credentials are revoked.

**Feature Overview:**
The warehouse reporting engine preference controls whether the organization has access to direct warehouse query capabilities. When enabled, users get database credentials for BI/reporting tools. When disabled, all reporting credentials are revoked for security.

**Preference Behavior:**
- **Preference Key**: WAREHOUSE_REPORTING_ENGINE
- **Valid Values**: "true" (enable) or "false" (disable)
- **Scope**: Organization-wide (affects all reporting users)
- **Side Effects**: Creates/deletes database credentials and user accounts
- **Access Control**: Enables/disables BI tool and reporting access
- **Audit Trail**: Change is logged; credential creation/deletion tracked

**Database Integration:**
When toggled, this preference triggers warehouse database operations:
- **Enable (value="true")**:
  - Creates warehouse database user account for organization
  - Generates connection credentials (host, user, password)
  - Sets up data access permissions for reporting tables
  - User can now connect reporting tools (Tableau, Power BI, etc.)

- **Disable (value="false")**:
  - Revokes all warehouse database access for organization
  - Drops database user account and credentials
  - Reporting tools can no longer connect
  - No data is lost (source tables remain intact)

**Parameters:**
- `org_id` (required, Form): Organization UUID
- `key` (required, Form): Configuration key (WAREHOUSE_REPORTING_ENGINE)
- `value` (optional, Form): "true" (enable) or "false" (disable)

**Use Cases:**

1. **Reporting Access Provisioning**:
   - Enable for enterprises purchasing reporting license
   - Provision warehouse database access
   - Client: "Enable reporting for Enterprise customer"

2. **Access Revocation**:
   - Disable when subscription expires
   - Revoke all reporting credentials immediately
   - Client: "Customer cancelled support, disable reporting access"

3. **Security Incident Response**:
   - Quickly disable to revoke compromised credentials
   - Re-enable after security audit
   - Client: "Suspicious activity detected, disable and rotate credentials"

4. **Trial Period Management**:
   - Keep disabled during free trial
   - Enable only for paying customers
   - Client: "Activate reporting for converted trial account"

5. **Multi-Tenant Data Isolation**:
   - Per-organization database users (SOX/HIPAA compliance)
   - Reporting access follows subscription tier
   - Client: "Tier 1 customers get reporting, Tier 2 don't"

**Response Behavior:**
- **Success (200 OK)**: Preference set and database operation completed
  - Enable: Returns user credentials for database access
  - Disable: Confirms credentials have been revoked
- **Error (400/500)**: Database operation failed, credentials not changed

**Error Responses:**
- **200 OK**: Reporting engine preference successfully set
- **400 Bad Request**: Invalid parameters
- **401 Unauthorized**: Authentication failed
- **403 Forbidden**: User lacks permission
- **500 Internal Server Error**: Database credential operation failed

**Related Endpoints:**
- `PUT /set_grouping_dashboard_preference` - Dashboard aggregation toggle
- `PUT /set_grouping_purchase_order_preference` - PO aggregation toggle
- `PUT /get_db_credentials` - Retrieve database credentials

**Example Request:**
```bash
# Enable warehouse reporting
curl -X PUT "https://api.docbits.com/preferences/set_reporting_engine_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&key=WAREHOUSE_REPORTING_ENGINE&value=true"

# Disable reporting access
curl -X PUT "https://api.docbits.com/preferences/set_reporting_engine_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -H "Content-Type: application/x-www-form-urlencoded" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&key=WAREHOUSE_REPORTING_ENGINE&value=false"
```

**Example Python SDK Usage:**
```python
import requests

class DocBitsReportingClient:
    def __init__(self, api_url: str, token: str):
        self.api_url = api_url
        self.token = token
        self.headers = {"Authorization": f"Bearer {token}"}

    def set_reporting_access(self, org_id: str, enable: bool):
        """Enable or disable warehouse reporting access."""
        data = {
            "org_id": org_id,
            "key": "WAREHOUSE_REPORTING_ENGINE",
            "value": "true" if enable else "false"
        }
        response = requests.put(
            f"{self.api_url}/preferences/set_reporting_engine_preference",
            data=data,
            headers=self.headers,
            timeout=15
        )
        return response.model_dump_json()

client = DocBitsReportingClient("https://api.docbits.com", "token")

# Enable reporting
result = client.set_reporting_access(org_id="550e8400-...", enable=True)
logger.debug(f"Reporting enabled: {result.get('success')}")

# Disable reporting
result = client.set_reporting_access(org_id="550e8400-...", enable=False)
logger.debug(f"Reporting disabled: {result.get('success')}")
```

**Security Notes:**
- Database credentials are generated on-demand
- All credentials revoked immediately on disable
- No sharing of credentials between organizations
- Database-level row-level security enforced
- Audit logging for all credential events
 * @summary Enable or disable warehouse reporting engine for organization
 */
  const setReportingEnginePreferencePreferencesSetReportingEnginePreferencePut =
    (
      bodySetReportingEnginePreferencePreferencesSetReportingEnginePreferencePut: BodySetReportingEnginePreferencePreferencesSetReportingEnginePreferencePut,
    ) => {
      const formUrlEncoded = new URLSearchParams();
      formUrlEncoded.append(
        `org_id`,
        bodySetReportingEnginePreferencePreferencesSetReportingEnginePreferencePut.org_id,
      );
      formUrlEncoded.append(
        `key`,
        bodySetReportingEnginePreferencePreferencesSetReportingEnginePreferencePut.key,
      );
      if (
        bodySetReportingEnginePreferencePreferencesSetReportingEnginePreferencePut.value !==
        undefined
      ) {
        formUrlEncoded.append(
          `value`,
          bodySetReportingEnginePreferencePreferencesSetReportingEnginePreferencePut.value,
        );
      }

      return customAxiosInstance<unknown>({
        url: `/preferences/set_reporting_engine_preference`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      });
    };
  /**
 * Enables or disables purchase order (PO) data aggregation in the warehouse. When enabled, POs are grouped and aggregated for fast PO matching and analysis. When disabled, aggregated PO data is deleted to save storage.

**Feature Overview:**
Controls whether the system maintains aggregated views of purchase order data. Enabled = fast PO matching queries (100-500ms). Disabled = slower on-demand PO searches (5-30 seconds) but saves 10-40% warehouse storage.

**Warehouse Integration:**
- **Enable (value="true")**:
  - Inserts aggregated PO records into warehouse
  - Creates materialized view (MV) for fast joins
  - Starts background PO aggregation jobs
  - Enables 100-500ms PO matching queries

- **Disable (value="false")**:
  - Deletes all PO partitions and materialized views
  - Frees 10-40% warehouse storage
  - Uses Celery tasks for async deletion
  - PO searches revert to slower on-demand calculation

**Parameters:**
- `org_id` (required, Form): Organization UUID
- `value` (optional, Form): "true" (enable) or "false" (disable)

**Use Cases:**

1. **Storage Optimization**: Disable for test/demo organizations
2. **PO Matching Performance**: Enable for enterprises with high PO volume
3. **Cost Reduction**: Disable when warehouse exceeds capacity limits
4. **Feature Rollout**: Enable for subset of customers during beta
5. **Trial Period Management**: Keep disabled until subscription commitment

**Error Responses:**
- **200 OK**: Preference set and warehouse task queued
- **400 Bad Request**: Invalid parameters
- **401 Unauthorized**: Authentication failed
- **403 Forbidden**: Insufficient permissions
- **500 Internal Server Error**: Celery or database failure

**Related Endpoints:**
- `PUT /set_grouping_dashboard_preference` - Dashboard grouping toggle
- `PUT /set_reporting_engine_preference` - Reporting engine toggle

**Example Request:**
```bash
# Enable PO aggregation
curl -X PUT "https://api.docbits.com/preferences/set_grouping_purchase_order_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&value=true"

# Disable PO aggregation for storage savings
curl -X PUT "https://api.docbits.com/preferences/set_grouping_purchase_order_preference" \
  -H "Authorization: Bearer YOUR_TOKEN" \
  -d "org_id=550e8400-e29b-41d4-a716-446655440000&value=false"
```

**Performance Notes:**
- Enable operation: 10-20 minutes (depends on PO volume)
- Disable operation: 5-10 minutes (async deletion via Celery)
- With aggregation: 100-500ms PO queries
- Without aggregation: 5-30 seconds PO queries
- Storage saved: 10-40% of warehouse size
 * @summary Enable or disable purchase order data aggregation and grouping
 */
  const setGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePut =
    (
      bodySetGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePut: BodySetGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePut,
    ) => {
      const formUrlEncoded = new URLSearchParams();
      formUrlEncoded.append(
        `org_id`,
        bodySetGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePut.org_id,
      );
      if (
        bodySetGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePut.value !==
        undefined
      ) {
        formUrlEncoded.append(
          `value`,
          bodySetGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePut.value,
        );
      }

      return customAxiosInstance<unknown>({
        url: `/preferences/set_grouping_purchase_order_preference`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      });
    };
  /**
 * Enable/disable database reporting engine and manage DB user credentials.

**Functionality:**
Manages database reporting engine access by enabling or disabling DB user accounts.
When enabled, creates database credentials; when disabled, removes them. Requires
valid access key for security.

**Features:**
- Enable/disable database reporting engine per organization
- Automatic credential creation for DB access
- Secure access key validation
- Activity logging of credential changes
- Atomic enable/disable transactions

**Performance Characteristics:**
- Response time: 500-1000ms (includes DB user creation/deletion)
- Database operations: Single transaction with user management
- Activity log: Audit trail of credential changes

**Related Endpoints:**
- GET /get_warehouse_user_preference - Retrieve warehouse user settings
- PUT /reset_warhouse_user - Reset warehouse database user

**Use Cases:**
1. **Reporting Engine Setup** - Enable analytics database access
2. **User Access Control** - Disable reporting for users/orgs
3. **Security Management** - Rotate or revoke DB credentials
4. **Audit Trail** - Track credential lifecycle changes
5. **Integration Setup** - Configure BI tool database access
6. **Resource Management** - Control database user provisioning
 * @summary Configure database reporting engine credentials
 */
  const getDbCredentialsPreferencesGetDbCredentialsPut = (
    bodyGetDbCredentialsPreferencesGetDbCredentialsPut: BodyGetDbCredentialsPreferencesGetDbCredentialsPut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyGetDbCredentialsPreferencesGetDbCredentialsPut.org_id,
    );
    formUrlEncoded.append(
      `access_key`,
      bodyGetDbCredentialsPreferencesGetDbCredentialsPut.access_key,
    );
    formUrlEncoded.append(
      `enable_user`,
      bodyGetDbCredentialsPreferencesGetDbCredentialsPut.enable_user,
    );

    return customAxiosInstance<unknown>({
      url: `/preferences/get_db_credentials`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Reset warehouse database user by deleting and recreating credentials.

**Functionality:**
Performs a complete reset of warehouse reporting engine database user credentials.
Checks if warehouse reporting is enabled, deletes existing user, and creates new
credentials with fresh session state.

**Features:**
- Warehouse engine status validation
- Complete user credential reset
- Atomic delete + create transaction
- Fresh session initialization
- Error rollback on failure

**Performance Characteristics:**
- Response time: 1-2 seconds (includes user operations)
- Database operations: Delete user + create user in transaction
- Data impact: Session state reset only, no data loss

**Related Endpoints:**
- GET /get_warehouse_user_preference - Check warehouse settings
- PUT /get_db_credentials - Configure DB credentials

**Use Cases:**
1. **Credential Rotation** - Periodically reset user passwords
2. **Session Reset** - Clear active sessions and start fresh
3. **Troubleshooting** - Fix authentication issues
4. **Maintenance** - Rebuild warehouse connections
5. **Security** - Revoke and re-issue credentials
6. **Access Restoration** - Restore access after lock-out
 * @summary Reset warehouse database user credentials
 */
  const resetWarhouseUserPreferencesResetWarhouseUserPut = (
    bodyResetWarhouseUserPreferencesResetWarhouseUserPut: BodyResetWarhouseUserPreferencesResetWarhouseUserPut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyResetWarhouseUserPreferencesResetWarhouseUserPut.org_id,
    );

    return customAxiosInstance<unknown>({
      url: `/preferences/reset_warhouse_user`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Fetch warehouse database user configuration and connection settings.

**Functionality:**
Retrieves warehouse reporting engine database user preferences including connection
parameters, authentication details, and configuration for warehouse analytics access.
Returns full database settings if warehouse reporting is enabled.

**Features:**
- Warehouse engine status validation
- Complete user preference retrieval
- Connection parameter mapping
- Configuration defaults
- Error handling for disabled warehouse

**Performance Characteristics:**
- Response time: 100-200ms
- Caching: Candidate for user preference cache
- Data: < 1KB typical response
- No external API calls

**Related Endpoints:**
- PUT /reset_warhouse_user - Reset user credentials
- PUT /get_db_credentials - Configure credentials
- PUT /set_cache_preference - Set cache settings

**Use Cases:**
1. **Connection Configuration** - Get DB connection details for BI tools
2. **Settings Display** - Show warehouse settings in UI
3. **Authentication Setup** - Retrieve user credentials for connection
4. **System Integration** - Get settings for external connections
5. **Health Check** - Verify warehouse is configured
6. **Audit** - Review warehouse access configuration
 * @summary Retrieve warehouse reporting database user preferences
 */
  const getWarehouseUserPreferencePreferencesGetWarehouseUserPreferenceGet = (
    params: GetWarehouseUserPreferencePreferencesGetWarehouseUserPreferenceGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/get_warehouse_user_preference`,
      method: 'GET',
      params,
    });
  };
  /**
 * Set cache preferences including TTL and enable/disable status.

**Functionality:**
Configures caching behavior for specific cache groups including enable/disable
status and time-to-live (TTL) duration. Stores configuration in data vault with
activity logging for audit trail.

**Features:**
- Cache enable/disable per cache group
- TTL configuration in seconds
- Cache name mapping
- Activity logging
- Configuration validation
- Atomic preference updates

**Performance Characteristics:**
- Response time: 200-300ms
- Database operation: Single insert/update transaction
- Activity log: Complete audit trail
- Cache invalidation: Immediate for affected groups

**Related Endpoints:**
- GET /get_cache_preference - Retrieve cache settings
- GET /fetch_redis_cache_data - View cache contents
- PUT /set_bod_connection_stream_preference - Stream settings

**Use Cases:**
1. **Cache Optimization** - Adjust TTL for performance tuning
2. **Cache Management** - Enable/disable cache groups
3. **Memory Optimization** - Control cache footprint
4. **Performance Tuning** - Experiment with TTL values
5. **Feature Flags** - Toggle caching on/off
6. **Audit Trail** - Track configuration changes
 * @summary Configure cache settings for organization
 */
  const setCachePreferencePreferencesSetCachePreferencePut = (
    bodySetCachePreferencePreferencesSetCachePreferencePut: BodySetCachePreferencePreferencesSetCachePreferencePut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodySetCachePreferencePreferencesSetCachePreferencePut.org_id,
    );
    formUrlEncoded.append(
      `key`,
      bodySetCachePreferencePreferencesSetCachePreferencePut.key,
    );
    formUrlEncoded.append(
      `cache_name`,
      bodySetCachePreferencePreferencesSetCachePreferencePut.cache_name,
    );
    if (
      bodySetCachePreferencePreferencesSetCachePreferencePut.enable !==
      undefined
    ) {
      formUrlEncoded.append(
        `enable`,
        bodySetCachePreferencePreferencesSetCachePreferencePut.enable,
      );
    }
    if (
      bodySetCachePreferencePreferencesSetCachePreferencePut.ttl !== undefined
    ) {
      formUrlEncoded.append(
        `ttl`,
        bodySetCachePreferencePreferencesSetCachePreferencePut.ttl.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/preferences/set_cache_preference`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Fetch cache configuration for a specific cache group.

**Functionality:**
Retrieves cache preferences for a given key including enable status, TTL, and
cache name. Returns configuration from data vault with validation of key format.

**Features:**
- Cache preference lookup by key
- TTL and enable status retrieval
- Key format validation
- Default value handling
- Configuration response mapping

**Performance Characteristics:**
- Response time: 50-100ms
- Caching: Configuration typically cached
- Data: < 500 bytes typical
- No external API calls

**Related Endpoints:**
- PUT /set_cache_preference - Update cache settings
- GET /fetch_redis_cache_data - View actual cache data
- PUT /set_bod_connection_stream_preference - Stream settings

**Use Cases:**
1. **UI Configuration Display** - Show current cache settings
2. **Cache Status Check** - Verify cache is enabled
3. **TTL Verification** - Check current TTL value
4. **System Initialization** - Load cache config at startup
5. **Health Check** - Validate cache configuration
6. **Debugging** - Inspect cache behavior settings
 * @summary Retrieve cache preference settings
 */
  const getCachePreferencePreferencesGetCachePreferenceGet = (
    params: GetCachePreferencePreferencesGetCachePreferenceGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/get_cache_preference`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Set Bod Connection Stream Preference
   */
  const setBodConnectionStreamPreferencePreferencesSetBodConnectionStreamPreferencePut =
    (
      bodySetBodConnectionStreamPreferencePreferencesSetBodConnectionStreamPreferencePut: BodySetBodConnectionStreamPreferencePreferencesSetBodConnectionStreamPreferencePut,
    ) => {
      const formUrlEncoded = new URLSearchParams();
      formUrlEncoded.append(
        `org_id`,
        bodySetBodConnectionStreamPreferencePreferencesSetBodConnectionStreamPreferencePut.org_id,
      );
      formUrlEncoded.append(
        `value`,
        bodySetBodConnectionStreamPreferencePreferencesSetBodConnectionStreamPreferencePut.value,
      );

      return customAxiosInstance<unknown>({
        url: `/preferences/set_bod_connection_stream_preference`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      });
    };
  /**
   * @summary Get Bod Connection Stream Preference
   */
  const getBodConnectionStreamPreferencePreferencesGetBodConnectionStreamPreferenceGet =
    (
      params: GetBodConnectionStreamPreferencePreferencesGetBodConnectionStreamPreferenceGetParams,
    ) => {
      return customAxiosInstance<unknown>({
        url: `/preferences/get_bod_connection_stream_preference`,
        method: 'GET',
        params,
      });
    };
  /**
   * @summary Send Message
   */
  const sendMessagePreferencesSendMessagePut = (
    bodySendMessagePreferencesSendMessagePut: BodySendMessagePreferencesSendMessagePut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `message`,
      bodySendMessagePreferencesSendMessagePut.message,
    );
    if (bodySendMessagePreferencesSendMessagePut.org_id !== undefined) {
      formUrlEncoded.append(
        `org_id`,
        bodySendMessagePreferencesSendMessagePut.org_id,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/preferences/send_message`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Fetch Redis Cache Data
   */
  const fetchRedisCacheDataPreferencesFetchRedisCacheDataGet = (
    params: FetchRedisCacheDataPreferencesFetchRedisCacheDataGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/preferences/fetch_redis_cache_data`,
      method: 'GET',
      params,
    });
  };
  return {
    deleteCacheForOrgPreferencesDeleteCacheForOrgDelete,
    getPreferencesPreferencesGetPreferencesGet,
    getUserPreferencesPreferencesGetUserPreferencesGet,
    getPreferencePreferencesGetPreferenceGet,
    getUserPreferencePreferencesGetUserPreferenceGet,
    getTfidfPreferenceSyncPreferencesGetTfidfPreferenceGet,
    setPreferencePreferencesSetPreferencePut,
    setPreferencesPreferencesSetPreferencesPut,
    setUserPreferenceSyncPreferencesSetUserPreferencePut,
    setUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut,
    setTfidfPreferencePreferencesSetTfidfPreferencePut,
    getTfidfPreferencesByOrgIdPreferencesGetTfidfPreferencesByOrgIdGet,
    removeTfidfPreferencesPreferencesRemoveTfidfPreferencesDelete,
    removePreferencePreferencesRemovePreferenceDelete,
    removeUserPreferencePreferencesRemoveUserPreferenceDelete,
    getSupportedBarcodeTypesPreferencesGetSupportedBarcodeTypesGet,
    updateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost,
    getOrganisationPreferencePreferencesGetOrganisationPreferencePost,
    getDocumentTypeRegexesPreferencesGetDocumentTypeRegexesPost,
    setGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut,
    setReportingEnginePreferencePreferencesSetReportingEnginePreferencePut,
    setGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePut,
    getDbCredentialsPreferencesGetDbCredentialsPut,
    resetWarhouseUserPreferencesResetWarhouseUserPut,
    getWarehouseUserPreferencePreferencesGetWarehouseUserPreferenceGet,
    setCachePreferencePreferencesSetCachePreferencePut,
    getCachePreferencePreferencesGetCachePreferenceGet,
    setBodConnectionStreamPreferencePreferencesSetBodConnectionStreamPreferencePut,
    getBodConnectionStreamPreferencePreferencesGetBodConnectionStreamPreferenceGet,
    sendMessagePreferencesSendMessagePut,
    fetchRedisCacheDataPreferencesFetchRedisCacheDataGet,
  };
};
export type DeleteCacheForOrgPreferencesDeleteCacheForOrgDeleteResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['deleteCacheForOrgPreferencesDeleteCacheForOrgDelete']
      >
    >
  >;
export type GetPreferencesPreferencesGetPreferencesGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getUserPreferences
      >['getPreferencesPreferencesGetPreferencesGet']
    >
  >
>;
export type GetUserPreferencesPreferencesGetUserPreferencesGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getUserPreferencesPreferencesGetUserPreferencesGet']
      >
    >
  >;
export type GetPreferencePreferencesGetPreferenceGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getUserPreferences
      >['getPreferencePreferencesGetPreferenceGet']
    >
  >
>;
export type GetUserPreferencePreferencesGetUserPreferenceGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getUserPreferencePreferencesGetUserPreferenceGet']
      >
    >
  >;
export type GetTfidfPreferenceSyncPreferencesGetTfidfPreferenceGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getTfidfPreferenceSyncPreferencesGetTfidfPreferenceGet']
      >
    >
  >;
export type SetPreferencePreferencesSetPreferencePutResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getUserPreferences
      >['setPreferencePreferencesSetPreferencePut']
    >
  >
>;
export type SetPreferencesPreferencesSetPreferencesPutResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getUserPreferences
      >['setPreferencesPreferencesSetPreferencesPut']
    >
  >
>;
export type SetUserPreferenceSyncPreferencesSetUserPreferencePutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['setUserPreferenceSyncPreferencesSetUserPreferencePut']
      >
    >
  >;
export type SetUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['setUserPreferenceAsyncEndpointPreferencesSetUserPreferenceAsyncPut']
      >
    >
  >;
export type SetTfidfPreferencePreferencesSetTfidfPreferencePutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['setTfidfPreferencePreferencesSetTfidfPreferencePut']
      >
    >
  >;
export type GetTfidfPreferencesByOrgIdPreferencesGetTfidfPreferencesByOrgIdGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getTfidfPreferencesByOrgIdPreferencesGetTfidfPreferencesByOrgIdGet']
      >
    >
  >;
export type RemoveTfidfPreferencesPreferencesRemoveTfidfPreferencesDeleteResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['removeTfidfPreferencesPreferencesRemoveTfidfPreferencesDelete']
      >
    >
  >;
export type RemovePreferencePreferencesRemovePreferenceDeleteResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['removePreferencePreferencesRemovePreferenceDelete']
      >
    >
  >;
export type RemoveUserPreferencePreferencesRemoveUserPreferenceDeleteResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['removeUserPreferencePreferencesRemoveUserPreferenceDelete']
      >
    >
  >;
export type GetSupportedBarcodeTypesPreferencesGetSupportedBarcodeTypesGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getSupportedBarcodeTypesPreferencesGetSupportedBarcodeTypesGet']
      >
    >
  >;
export type UpdateOrganisationPreferencePreferencesUpdateOrganisationPreferencePostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['updateOrganisationPreferencePreferencesUpdateOrganisationPreferencePost']
      >
    >
  >;
export type GetOrganisationPreferencePreferencesGetOrganisationPreferencePostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getOrganisationPreferencePreferencesGetOrganisationPreferencePost']
      >
    >
  >;
export type GetDocumentTypeRegexesPreferencesGetDocumentTypeRegexesPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getDocumentTypeRegexesPreferencesGetDocumentTypeRegexesPost']
      >
    >
  >;
export type SetGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['setGroupingDashboardPreferencePreferencesSetGroupingDashboardPreferencePut']
      >
    >
  >;
export type SetReportingEnginePreferencePreferencesSetReportingEnginePreferencePutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['setReportingEnginePreferencePreferencesSetReportingEnginePreferencePut']
      >
    >
  >;
export type SetGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['setGroupingPurchaseOrderPreferencePreferencesSetGroupingPurchaseOrderPreferencePut']
      >
    >
  >;
export type GetDbCredentialsPreferencesGetDbCredentialsPutResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getUserPreferences
      >['getDbCredentialsPreferencesGetDbCredentialsPut']
    >
  >
>;
export type ResetWarhouseUserPreferencesResetWarhouseUserPutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['resetWarhouseUserPreferencesResetWarhouseUserPut']
      >
    >
  >;
export type GetWarehouseUserPreferencePreferencesGetWarehouseUserPreferenceGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getWarehouseUserPreferencePreferencesGetWarehouseUserPreferenceGet']
      >
    >
  >;
export type SetCachePreferencePreferencesSetCachePreferencePutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['setCachePreferencePreferencesSetCachePreferencePut']
      >
    >
  >;
export type GetCachePreferencePreferencesGetCachePreferenceGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getCachePreferencePreferencesGetCachePreferenceGet']
      >
    >
  >;
export type SetBodConnectionStreamPreferencePreferencesSetBodConnectionStreamPreferencePutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['setBodConnectionStreamPreferencePreferencesSetBodConnectionStreamPreferencePut']
      >
    >
  >;
export type GetBodConnectionStreamPreferencePreferencesGetBodConnectionStreamPreferenceGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['getBodConnectionStreamPreferencePreferencesGetBodConnectionStreamPreferenceGet']
      >
    >
  >;
export type SendMessagePreferencesSendMessagePutResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getUserPreferences
      >['sendMessagePreferencesSendMessagePut']
    >
  >
>;
export type FetchRedisCacheDataPreferencesFetchRedisCacheDataGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getUserPreferences
        >['fetchRedisCacheDataPreferencesFetchRedisCacheDataGet']
      >
    >
  >;
